import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Renderer2,
  SimpleChanges,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { cloneDeep, isEqual } from 'lodash-es';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { UtilService } from 'src/app/services/util.service';
import { ApiConstants } from 'src/app/base/api-constants';
import { MessageService } from 'primeng/api';
import { DMConstants, nodeType } from 'src/app/pages/designs/data-model/data-model.component';
import { metaInfo } from 'src/app/STORE/selectors/applifecycle.selector';
import { DialogService } from 'primeng/dynamicdialog';
import { PreValidationTblViewComponent } from '../pre-validation-tbl-view/pre-validation-tbl-view.component';
import { GlobalConstants } from 'src/app/base/global.constants';
import { TreeDragDropService } from 'primeng/api';
import { v4 as uuidv4 } from 'uuid';
import { FsBaseService } from 'src/app/services/fs-base.service';
import { updateAppDM } from 'src/app/STORE/actions/applicationdatamodel.actions';
import { getIndices, setIndices } from 'src/app/STORE/actions/indexdesigner.actions';
import { indices } from 'src/app/STORE/selectors/indexdesigner.selector';

export enum cudAction {
  INSERT = 'INSERT',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  UPSERT = 'UPSERT',
  ACTIVATE = 'ACTIVATE',
  DEACTIVATE = 'DEACTIVATE',
  NOACTION = 'NO_ACTION'
}

enum tableAction {
  NEW_RECORD = 'NEW_RECORD',
  UPDATE_RECORD = 'UPDATE_RECORD',
  DELETE_RECORD = 'DELETE_RECORD',
  ACTIVATE_RECORD = 'ACTIVATE_RECORD',
  DEACTIVATE_RECORD = 'DEACTIVATE_RECORD'
}

type DynamicKeyValueType = Record<string, any>;
type RecordIdentifierLookup = {
  byAliasId: Map<string, string | null>;
  byTableId: Map<string, string[]>;
};

@Component({
  selector: 'vb-cud-config',
  templateUrl: './cud-config.component.html',
  styleUrls: ['./cud-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CudConfigComponent),
      multi: true
    },
    TreeDragDropService
  ],
  standalone: false  //NOSONAR
})
export class CudConfigComponent implements OnInit, AfterViewInit, OnDestroy {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private store = inject(Store);
  private baseService = inject(HttpBaseService);
  private util = inject(UtilService);
  private translateService = inject(TranslateService);
  private messageService = inject(MessageService);
  private appGlobalService = inject(AppGlobalService);
  private cdr = inject(ChangeDetectorRef);
  private bs = inject(HttpBaseService);
  private dialogService = inject(DialogService);
  private fsService = inject(FsBaseService);
  private oldAction: any;

  private modelValue: any;

  private _model: any;
  @Input() fsData: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;

  @Input() element: any;
  @Input() formData: any;
  @Input() disableField = false;
  @Input() currentScreen: any;
  @Input() currentNode: any = null;
  @Input() currNodeType: any = null;
  @Input() dataModelOrders;
  lastSelectedQbProp: any = {};
  tableOrders: any[] = [];
  subscriptions: Subscription[] = [];
  showCudConfig = false;
  errorMessage: any;
  activeIndex: any;
  allTableData: any[] = [];
  currentTableId: any;
  appId = this.appGlobalService.get('appId');
  orgId = this.appGlobalService.get('orgId');
  tableOptions: any[] = [];
  tableValue: any[] = [];
  tableAliasValue: any = [];
  fieldTOptions: any[] = [];
  fieldOptions: any[] = [];
  queryFieldData: any[] = [];
  metaInfoMap: any;
  tableMap: any = {};
  isDeactivateRecords: boolean = false;
  create: boolean = false;
  globalResults: any;
  mappingsChange: any = {};
  applicationMetaData: any;
  reorderActions: any[] = [];
  showQueryBuilder: boolean = false;
  conditionProperty: any;
  conditional: any;
  cudActionsMap = {
    noAction: {
      name: 'No Action',
      value: cudAction.NOACTION
    },
    insert: {
      name: 'Insert',
      value: cudAction.INSERT
    },
    upsert: {
      name: 'Upsert',
      value: cudAction.UPSERT
    },
    update: {
      name: 'Update',
      value: cudAction.UPDATE
    },
    delete: {
      name: 'Delete',
      value: cudAction.DELETE
    },
    activate: {
      name: 'Activate',
      value: cudAction.ACTIVATE
    },
    deactivate: {
      name: 'Deactivate',
      value: cudAction.DEACTIVATE
    }
  };
  cudActions = [
    this.cudActionsMap.noAction,
    this.cudActionsMap.insert,
    this.cudActionsMap.upsert,
    this.cudActionsMap.update,
    this.cudActionsMap.delete,
    this.cudActionsMap.activate,
    this.cudActionsMap.deactivate
  ];
  actionOrder = ['create', 'update', 'delete'];
  cudActionOrder: DynamicKeyValueType = {
    create: [],
    update: [],
    delete: []
  };
  enabledActions: DynamicKeyValueType = {
    create: { name: 'ACT_CREATE', value: true, keyName: cudAction.INSERT },
    update: { name: 'ACT_UPD', value: true, keyName: cudAction.UPDATE },
    delete: { name: 'ACT_DEL', value: true, keyName: cudAction.DELETE }
  };
  backupData: any = {};
  payload: any;
  tableNames = '';
  errorData = null;
  isLoading = false;
  selectedTables: DynamicKeyValueType = {
    create: [],
    update: [],
    delete: []
  };
  indexMap = new Map();
  private pendingIndexTableIds: string[] = [];
  private fsCudSub: Subscription | null = null;
  private cudInitial = true;
  cudAliases: any[] = [];

  // Record Identifier properties
  showRecordIdentifierDialog = false;
  selectedAliasForRI: any = null;
  availableIndexesForRI: any[] = [];
  selectedIndexSidForRI: string | null = null;
  aliasMenuItems: any[] = [];

  // Carousel properties
  numVisible = 3;
  showNavigators = true;
  responsiveOptions = [
    {
      breakpoint: '1400px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '1199px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '767px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '575px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.modelValue = value;
    const sub = this.baseService.get(ApiConstants.getCud, { tableId: this.currentTableId }).subscribe(
      (results: any) => {
        this.globalResults = results;
        if (results?.qvTableAliases) {
          const parsedModel = this.sortByCreatedDate(JSON.parse(results.qvTableAliases));

          this.tableAliasValue = parsedModel.map((tav) => this.mapAliasFromResponse(tav));
          this.fetchAndCacheIndicesForAliases();

          const transformed = parsedModel.map((aliasObj) => {
            return {
              appId: aliasObj.appId,
              table: aliasObj.t_tableId,
              alias: JSON.stringify({
                name: aliasObj.aliasName,
                sid: aliasObj.sid
              })
            };
          });
          this.modelValue = transformed;
        } else {
          this.modelValue = value;
        }
      },
      (err) => {
        console.error(err);
        this.modelValue = value;
      }
    );
    this.addToSubscriptionsList(sub);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    // this.disabled = isDisabled;
  }

  addToSubscriptionsList(subName) {
    this.subscriptions.push(subName);
  }

  onChildButtonClick() {
    this.showCudConfig = false;
  }

  stopDropdownClose(evt: Event) {
    evt.stopPropagation();
  }

  getAliasNameBySid(sid: string) {
    const match = this.tableAliasValue.find((item) => item.aliasId === sid);
    return match?.alias;
  }

  private getCudPrevalidationMetaData(): Record<string, string> {
    const metaData: Record<string, string> = {};
    const appendMeta = (id?: string, name?: string) => {
      if (id && name) {
        metaData[id] = name;
      }
    };

    this.tableOptions.forEach((table) => appendMeta(table?.id, table?.name));
    this.fieldOptions.forEach((table) => (table?.items || []).forEach((field) => appendMeta(field?.id, field?.name)));
    this.queryFieldData.forEach((field) => appendMeta(field?.id, field?.name));
    this.tableAliasValue.forEach((alias) => appendMeta(alias?.aliasId, alias?.alias || alias?.aliasBackup));

    return metaData;
  }

  private openCudPreValidationModal(err: any): void {
    const preValmodal = this.dialogService.open(PreValidationTblViewComponent, {
      showHeader: false,
      styleClass: 'reference-tree',
      modal: true,
      data: {
        prevalidationList: {
          preValicationList: err,
          type: 'cudConfig',
          aiMetaData: this.getCudPrevalidationMetaData()
        }
      }
    });
    let sub = preValmodal.onClose.subscribe((data: any) => {
      if (data) {
        this.callApi(this.payload, true, false, false, false);
      }
    });
    this.subscriptions.push(sub);
  }

  private parseAliasValue(alias: any): { sid?: string; name?: string } {
    if (!alias) {
      return {};
    }
    if (typeof alias === 'string') {
      try {
        return JSON.parse(alias);
      } catch (e) {
        return {};
      }
    }
    return alias;
  }

  private normalizeIndexSid(indexSids: unknown, fallbackIndexSid?: unknown): string | null {
    if (typeof fallbackIndexSid === 'string' && fallbackIndexSid) {
      return fallbackIndexSid;
    }
    if (typeof indexSids === 'string' && indexSids) {
      return indexSids;
    }
    if (Array.isArray(indexSids)) {
      const firstSid = indexSids.find((sid): sid is string => typeof sid === 'string' && !!sid);
      return firstSid || null;
    }
    return null;
  }

  private buildRecordIdentifierLookup(aliases: any[]): RecordIdentifierLookup {
    const byAliasId = new Map<string, string | null>();
    const byTableId = new Map<string, string[]>();

    (aliases || []).forEach((alias) => {
      const aliasId = alias?.aliasId || alias?.sid;
      const tableId = alias?.table || alias?.t_tableId;
      const normalizedIndexSid = this.normalizeIndexSid(alias?.indexSids, alias?.indexSid);

      if (aliasId) {
        byAliasId.set(aliasId, normalizedIndexSid);
      }
      if (tableId && normalizedIndexSid) {
        const existing = byTableId.get(tableId) || [];
        byTableId.set(tableId, existing.includes(normalizedIndexSid) ? existing : [...existing, normalizedIndexSid]);
      }
    });

    return { byAliasId, byTableId };
  }

  private getCurrentRecordIdentifierLookup(): RecordIdentifierLookup {
    return this.buildRecordIdentifierLookup(this.tableAliasValue);
  }

  private getSavedRecordIdentifierLookup(): RecordIdentifierLookup {
    const savedAliases = JSON.parse(this.globalResults?.qvTableAliases || '[]');
    return this.buildRecordIdentifierLookup(savedAliases);
  }

  private getAliasRecordIdentifierFieldIds(
    aliasId?: string,
    tableIdOverride?: string,
    indexSidOverride?: string | null
  ): string[] {
    if (!aliasId && !tableIdOverride) {
      return [];
    }

    const currentAlias = this.tableAliasValue.find((alias) => (alias?.aliasId || alias?.sid) === aliasId);
    const savedAliases = JSON.parse(this.globalResults?.qvTableAliases || '[]');
    const savedAlias = savedAliases.find((alias) => (alias?.aliasId || alias?.sid) === aliasId);
    const aliasRecord = currentAlias || savedAlias;
    const tableId = tableIdOverride || aliasRecord?.table || aliasRecord?.t_tableId;
    const indexSid = indexSidOverride || this.normalizeIndexSid(aliasRecord?.indexSids, aliasRecord?.indexSid);

    if (!tableId || !indexSid) {
      return [];
    }

    const indexes = this.indexMap.get(tableId) || [];
    const matchedIndex = indexes.find((index) => index.sid === indexSid);

    return matchedIndex ? this.parseIndexFieldIds(matchedIndex.fields) : [];
  }

  private getIndexSidForFieldMapping(
    mapping: any,
    lookup: RecordIdentifierLookup,
    aliasIdOverride?: string
  ): string | null {
    const parsedAlias = this.parseAliasValue(mapping?.alias);
    const aliasId = aliasIdOverride || mapping?.aliasId || parsedAlias?.sid;
    const tableId = mapping?.tableId || mapping?.table;
    const fieldId = mapping?.fieldId || mapping?.tfield;
    const configuredIndexSid = aliasId ? lookup.byAliasId.get(aliasId) || null : null;

    if (configuredIndexSid && fieldId) {
      const recordIdentifierFieldIds = this.getAliasRecordIdentifierFieldIds(aliasId, tableId, configuredIndexSid);

      if (recordIdentifierFieldIds.includes(fieldId)) {
        return configuredIndexSid;
      }
    }

    const existingIndexSid = this.normalizeIndexSid(mapping?.indexSids, mapping?.indexSid);
    if (existingIndexSid) {
      const recordIdentifierFieldIds = this.getAliasRecordIdentifierFieldIds(aliasId, tableId, existingIndexSid);

      if (!fieldId || recordIdentifierFieldIds.length === 0 || recordIdentifierFieldIds.includes(fieldId)) {
        return existingIndexSid;
      }
    }

    const tableIndexSids = tableId ? lookup.byTableId.get(tableId) || [] : [];

    if (tableIndexSids.length === 1 && fieldId) {
      const [tableIndexSid] = tableIndexSids;
      const recordIdentifierFieldIds = this.getAliasRecordIdentifierFieldIds(aliasId, tableId, tableIndexSid);

      if (recordIdentifierFieldIds.includes(fieldId)) {
        return tableIndexSid;
      }
    }

    return null;
  }

  private getFieldMappingSignature(
    mapping: any,
    lookup: RecordIdentifierLookup,
    aliasIdOverride?: string
  ): string {
    const parsedAlias = this.parseAliasValue(mapping?.alias);
    const aliasId = aliasIdOverride || mapping?.aliasId || parsedAlias?.sid || '';
    const normalizedIndexSid = this.normalizeIndexSid(mapping?.indexSids, mapping?.indexSid)
      || this.getIndexSidForFieldMapping(mapping, lookup, aliasId);

    return JSON.stringify({
      aliasId,
      tableId: mapping?.tableId || mapping?.table || '',
      fieldId: mapping?.fieldId || mapping?.tfield || '',
      uniqueIdGenReq: mapping?.uniqueIdGenReq ?? false,
      indexSid: normalizedIndexSid
    });
  }

  private areFieldMappingsEquivalent(
    currentMappings: any[],
    currentLookup: RecordIdentifierLookup,
    backupMappings: any[],
    backupLookup: RecordIdentifierLookup
  ): boolean {
    if ((currentMappings?.length || 0) !== (backupMappings?.length || 0)) {
      return false;
    }

    const counts = new Map<string, number>();

    (currentMappings || []).forEach((mapping) => {
      const signature = this.getFieldMappingSignature(mapping, currentLookup);
      counts.set(signature, (counts.get(signature) || 0) + 1);
    });

    for (const mapping of backupMappings || []) {
      const signature = this.getFieldMappingSignature(mapping, backupLookup);
      const count = counts.get(signature);

      if (!count) {
        return false;
      }

      if (count === 1) {
        counts.delete(signature);
      } else {
        counts.set(signature, count - 1);
      }
    }

    return counts.size === 0;
  }

  setValueToSteps(results?: any) {
    this.globalResults = results;
    this.reorderActions = [];
    try {
      if (results?.qvTableAliases) {
        const parsedModel = this.sortByCreatedDate(JSON.parse(results.qvTableAliases));

        this.tableAliasValue = parsedModel.map((tav) => this.mapAliasFromResponse(tav));
        this.fetchAndCacheIndicesForAliases();

        const transformed = parsedModel.map((aliasObj) => {
          return {
            appId: aliasObj.appId,
            table: aliasObj.t_tableId,
            alias: JSON.stringify({
              name: aliasObj.aliasName,
              sid: aliasObj.sid
            })
          };
        });
        this.backupData = {
          ...this.backupData,
          t_cud_qv_tables: transformed
        };
        this.modelValue = transformed;
      } else if (this.modelValue) {
        const parsedModel = JSON.parse(this.modelValue);
        this.tableAliasValue = parsedModel.map((tav) => {
          const parsedAlias = JSON.parse(tav.alias);
          return {
            ...tav,
            aliasId: parsedAlias?.sid,
            alias: parsedAlias?.name,
            name: this.metaInfoMap[tav.table],
            aliasBackup: parsedAlias.name,
            isInvalid: false,
            errorMessage: ''
          };
        });

        this.backupData = {
          ...this.backupData,
          t_cud_qv_tables: this.modelValue
        };
      } else {
        this.tableAliasValue = [];
        this.backupData = {
          ...this.backupData,
          t_cud_qv_tables: null
        };
      }

      // // Configure the data for step 2 & 3, so that value can be set
      this.configureForStep2(tableAction.NEW_RECORD);
      this.configureForStep3(tableAction.NEW_RECORD);

      const transformedFieldMappings: Record<string, any[]> = {};
      const currentRecordIdentifierLookup = this.getCurrentRecordIdentifierLookup();

      const parsedMappings = JSON.parse(results.qvFieldMappings);

      parsedMappings.forEach((mapping: any) => {
        const qvFieldId = mapping.qvFieldId;

        if (!transformedFieldMappings[qvFieldId]) {
          transformedFieldMappings[qvFieldId] = [];
        }

        mapping.fieldMapping.forEach((fm: any) => {
          transformedFieldMappings[qvFieldId].push({
            appId: mapping.appId,
            tfield: fm.fieldId,
            table: fm.tableId,
            alias: JSON.stringify({
              name: this.getAliasNameBySid(fm.aliasId),
              sid: fm.aliasId
            }),
            uniqueIdGenReq: fm.uniqueIdGenReq,
            indexSid: this.getIndexSidForFieldMapping(fm, currentRecordIdentifierLookup, fm.aliasId)
          });
        });
      });

      this.formData.t_cud_qv_mapping = JSON.stringify(transformedFieldMappings);

      if (this.formData.t_cud_qv_mapping) {
        const fMappedData = JSON.parse(this.formData.t_cud_qv_mapping);
        if (fMappedData) {
          this.queryFieldData.forEach((qfd) => {
            const mappedData = fMappedData[qfd.id];
            if (mappedData && mappedData.length) {
              qfd.tfield = mappedData.map((value) => {
                const parsedAlias = JSON.parse(value.alias);
                value.alias = parsedAlias.name;
                return (
                  qfd.options
                    .find((option) => option.alias === value.alias)
                    ?.children.find((child) => child.data.tfield === value.tfield) ?? null
                );
              });
              if(!qfd.tfield || qfd.tfield.length==0 || qfd.tfield[0]==null)
              {
                qfd.tfield=[];
              }
              qfd.uniqueIdGenReq = mappedData[0].uniqueIdGenReq;
            } else {
              qfd.tfield = [];
            }
          });
          this.backupData = { ...this.backupData, ...{ t_cud_qv_mapping: this.formData.t_cud_qv_mapping } };
        } else {
          this.backupData = { ...this.backupData, ...{ t_cud_qv_mapping: null } };
        }
      } else {
        this.backupData = { ...this.backupData, ...{ t_cud_qv_mapping: null } };
      }

      const parsedActions = JSON.parse(results.qvActions);
      const transform = (arr = []) => {
        return arr.map((item: any) => {
          return {
            appId: item.appId,
            action: item.action,
            sid: item?.sid,
            table: item.t_tableId,
            queryBuilderId: item?.queryBuilderId,
            alias: JSON.stringify({
              name: this.getAliasNameBySid(item.aliasId),
              sid: item.aliasId
            })
          };
        });
      };
      const transformedActions = {
        disabled: parsedActions.disabled,
        create: transform(parsedActions.create),
        update: transform(parsedActions.update),
        delete: transform(parsedActions.delete),
        ...(this.isDeactivateRecords && parsedActions.activate ? { activate: transform(parsedActions.activate) } : []),
        ...(this.isDeactivateRecords && parsedActions.deactivate
          ? { deactivate: transform(parsedActions.deactivate) }
          : [])
      };
      this.formData.t_cud_qv_action_order = JSON.stringify(transformedActions);

      if (this.formData.t_cud_qv_action_order) {
        const actionOrder = JSON.parse(this.formData.t_cud_qv_action_order);
        const enabledActs = cloneDeep(this.enabledActions);
        Object.keys(enabledActs).forEach((act) => {
          enabledActs[act].value = !actionOrder?.disabled?.includes(enabledActs[act].keyName);
        });
        this.enabledActions = cloneDeep(enabledActs);
        delete actionOrder.disabled;
        this.cudActionOrder = actionOrder;
        this.cudActionOrder = {
          create: this.mapActionsPayload(actionOrder, 'create'),
          update: this.mapActionsPayload(actionOrder, 'update'),
          delete: this.mapActionsPayload(actionOrder, 'delete'),
          ...(this.isDeactivateRecords && actionOrder.activate
            ? { activate: this.mapActionsPayload(actionOrder, 'activate') }
            : { activate: [] }),
          ...(this.isDeactivateRecords && actionOrder.deactivate
            ? { deactivate: this.mapActionsPayload(actionOrder, 'deactivate') }
            : { deactivate: [] })
        };
        Object.keys(actionOrder).forEach((act) => {
          this.selectedTables[act] = [actionOrder[act][0]];
        });
        this.backupData = { ...this.backupData, ...{ t_cud_qv_action_order: this.formData.t_cud_qv_action_order } };
      } else {
        this.backupData = { ...this.backupData, ...{ t_cud_qv_action_order: null } };
      }
    } catch (e) {
      console.log(e);
    }
  }

  mapActionsPayload(actionOrder: any, actionName: any) {
    return (
      actionOrder[actionName]?.map((action) => {
        const parsedAlias = JSON.parse(action.alias);
        const tav = this.tableAliasValue.find((tavElement: any) => tavElement.alias === parsedAlias.name);
        return {
          ...action,
          ...{
            alias: parsedAlias.name,
            aliasId: parsedAlias.sid,
            label: `${tav.name} (${tav.alias})`
          }
        };
      }) || []
    );
  }

  /**
   * To handle the closure of popup when escape button is clicked and when popup is opened
   */
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.showCudConfig) {
      this.closePopup();
    }
  }
  step2change() {
    if (!this.mappingsChange) {
      return false;
    }
    return Object.values(this.mappingsChange).some((val) => val === true);
  }

  step3change(actionOrder: any): boolean {
    if (!actionOrder) {
      return false;
    }
    const actionKeys = Object.keys(actionOrder).filter((key) => Array.isArray(actionOrder[key]));
    for (const key of actionKeys) {
      if (actionOrder[key].some((item: any) => item.hasChange === true)) {
        return true;
      }
    }
    return false;
  }

  closePopup() {
    let data: any = this.formDataForSave();
    if (
      this.step1Valueschange(JSON.parse(data?.t_cud_qv_tables || '[]')) ||
      this.step2Valueschange(JSON.parse(data?.t_cud_qv_mapping || '{}')) ||
      this.step3Valueschange(JSON.parse(data?.t_cud_qv_action_order || '{}'))
    ) {
      this.confirmationDialogService.confirm({
        message: this.translateService.instant('UN_SAVED_CUD'),
          header: this.translateService.instant('CONFIRMATION'),
        accept: () => {
          // Reset data to last saved state before closing
          this.resetFormData();
          this.showCudConfig = false;
          this.activeIndex = 0;
        },
        reject: () => {
          /* empty */
        }
      });
    } else {
      this.showCudConfig = false;
      this.activeIndex = 0;
    }
  }

  /**
   * Reset form data to last saved state or initial empty state
   */
  resetFormData() {
    // If there was saved data, restore it
    if (!this.create && this.globalResults) {
      this.setValueToSteps(this.globalResults);
    } else {
      // No saved data exists, reset to empty state
      this.tableAliasValue = [];
      this.queryFieldData.forEach((qfd) => {
        qfd.tfield = null;
        qfd.uniqueIdGenReq = false;
      });
      this.cudActionOrder = {
        create: [],
        update: [],
        delete: []
      };
      this.formData.t_cud_qv_mapping = null;
      this.formData.t_cud_qv_action_order = null;
      this.mappingsChange = {};
    }
  }

  addTableAlias(table) {
    const alias = this.generateAliasName(table.name);
    this.tableAliasValue.push({
      aliasId: uuidv4(),
      appId: this.appId,
      table: table.id,
      name: table.name,
      alias,
      aliasBackup: alias,
      isInvalid: false,
      errorMessage: '',
      indexSid: null,
      recordIdentifierIndexName: null,
      recordIdentifierFields: null
    });
    this.onTableAliasValueChange(tableAction.NEW_RECORD);
  }

  deleteAlias(index) {
    this.confirmationDialogService.confirm({
      message: this.translateService.instant('TABLE_REMOV_CUD'),
        header: this.translateService.instant('CONFIRMATION'),
      accept: () => {
        const deletedTableAlias = this.tableAliasValue[index];
        this.tableAliasValue.splice(index, 1);
        this.onTableAliasValueChange(tableAction.DELETE_RECORD, deletedTableAlias.aliasId);
      },
      reject: () => {
        console.log("rejected")
      }
    });
  }

  generateAliasName(tableName) {
    // Check whether table name can be added as alias
    const tableNameForAlias = tableName.replace(/ /g, '');
    if (!this.tableAliasValue.filter((ta) => ta.alias === tableNameForAlias).length) {
      return tableNameForAlias;
    }

    let counter = 1;
    let aliasName = '';
    while (aliasName === '') {
      if (this.tableAliasValue.filter((ta) => ta.alias === tableNameForAlias + counter).length) {
        counter += 1;
      } else {
        aliasName = tableNameForAlias + counter;
      }
    }

    return aliasName;
  }

  onTableAliasValueChange(action: tableAction, aliasId?: string) {
    this.configureNewAliasForStep2(action, aliasId);
    this.configureNewAliasForStep3(action, aliasId);
  }

  updateAlias(aliasObj, index) {
    // Validate the whitespaces in alias name
    if (aliasObj.alias.indexOf(' ') !== -1) {
      aliasObj.isInvalid = true;
      aliasObj.errorMessage = this.translateService.instant('WHITESPACE_NOT_ALLOWED');
      this.util.showError(this.translateService.instant('WHITESPACE_NOT_ALLOWED'));
      return;
    }

    // Validate the name
    const { errorMessage } = this.util.validateTableName(aliasObj.alias, {}, true, false, true);
    if (errorMessage.name) {
      aliasObj.isInvalid = true;
      aliasObj.errorMessage = errorMessage.name;
      this.util.showError(errorMessage.name);
      return;
    }
    aliasObj.isInvalid = false;
    aliasObj.errorMessage = '';

    // If name is valid, the check for duplicates
    if (this.tableAliasValue.find((ta, i) => i !== index && ta.alias === aliasObj.alias)) {
      aliasObj.isInvalid = true;
      aliasObj.errorMessage = this.translateService.instant('DUPLICATE_ALIAS');
      this.util.showError(this.translateService.instant('DUPLICATE_ALIAS'));
    } else {
      aliasObj.isInvalid = false;
      aliasObj.errorMessage = '';
      aliasObj.aliasBackup = aliasObj.alias;

      // If there are no dupliactes, then trigger the onTableAliasValueChange
      this.onTableAliasValueChange(tableAction.UPDATE_RECORD, aliasObj.aliasId);
    }
  }

  onAliasFocusOut(table) {
    if (table.isInvalid) {
      table.isInvalid = false;
      table.alias = table.aliasBackup;
    }
  }

  onOptionsShow(column) {
    this.reorderOptions(column.id);
  }

  reorderOptions(queryFieldId) {
    const queryField = this.queryFieldData.find((qf) => qf.id === queryFieldId);
    if (queryField) {
      queryField.options?.forEach((option) => {
        const selectedFields: any[] = [];
        const unselectedFields: any[] = [];

        option.children.forEach((child) => {
          if (queryField.tfield?.find((tf) => tf.key === child.key)) {
            selectedFields.push(child);
          } else {
            unselectedFields.push(child);
          }
        });

        option.children = [...selectedFields, ...unselectedFields];
      });
    }
  }

  configureForStep2(action: tableAction, aliasId?: string) {
    if (this.queryFieldData.length === 0 || this.queryFieldData === null) {
      this.populateQueryFieldData();
    }
    if (action === tableAction.NEW_RECORD) {
      this.queryFieldData.forEach((qfd) => {
        const treeOptions: any[] = [];
        const queryFieldDataType = qfd.type;

        this.tableAliasValue.forEach((ta) => {
          let childrens = this.fieldOptions
            .find((fo) => fo.id === ta.t_tableId)
            .items.reduce((acc, field) => {
              let fieldType = field.type;
              if (
                (fieldType == queryFieldDataType ||
                  (['Auto-number', 'Number'].includes(queryFieldDataType) &&
                    ['Auto-number', 'Number'].includes(fieldType))) &&
                !GlobalConstants.auditFields.includes(field.name)
              ) {
                acc.push({
                  label: field.name,
                  selectedLabel: `${ta.name} (${ta.alias}) - ${field.name}`,
                  key: `${field.id}-${ta.aliasId}`,
                  aliasId: ta.aliasId,
                  styleClass: 'field-node',
                  data: {
                    appId: this.appId,
                    tfield: field.id,
                    table: ta.t_tableId,
                    alias: ta.alias
                  }
                });
              }
              return acc;
            }, []);

          if (childrens.length) {
            treeOptions.push({
              aliasId: ta.aliasId,
              label: `${ta.name} (${ta.alias})`,
              alias: ta.alias,
              selectable: false,
              styleClass: 'table-alias-node',
              expanded: true,
              type: 'table',
              children: childrens
            });
          }
        });

        qfd.options = treeOptions;
      });
    } else if (action === tableAction.UPDATE_RECORD) {
      // Find the updated tableAliasValue record
      const updatedTableAlias = this.tableAliasValue.find((tav) => tav.aliasId === aliasId);

      // Iterate over the queryFieldData
      this.queryFieldData.forEach((qfd) => {
        // Iterate over the options
        qfd?.options?.forEach((option) => {
          // If the option is tableAliasValue record ie, is updated, then update the label and children alias value
          if (option.aliasId === aliasId) {
            option.alias = updatedTableAlias.alias;
            option.label = `${updatedTableAlias.name} (${updatedTableAlias.alias})`;

            // Iterate over the option children
            option.children.forEach((child) => {
              child.alias = updatedTableAlias.alias;
              child.selectedLabel = `${updatedTableAlias.name} (${updatedTableAlias.alias}) - ${child.label}`;
              child.data.alias = updatedTableAlias.alias;
            });
          }
        });

        // Iterate over the tfield. If any record contains the same uniqueUUID, then update the alias there too
        qfd.tfield?.forEach((tf) => {
          if (tf.aliasId === aliasId) {
            tf.alias = updatedTableAlias.alias;
            tf.selectedLabel = `${updatedTableAlias.name} (${updatedTableAlias.alias}) - ${tf.label}`;
            tf.data.alias = updatedTableAlias.alias;
          }
        });
      });
    } else if (action === tableAction.DELETE_RECORD) {
      // Iterate over the queryFieldData
      this.queryFieldData.forEach((qfd) => {
        // Filter the options, so that deleted tableAliasValue can be removed
        qfd.options = qfd.options?.filter((option) => option && option.aliasId !== aliasId);

        // Filter the tfield, so that any selectedValue can be deselected
        qfd.tfield = qfd.tfield?.filter((tf) => tf && tf.aliasId !== aliasId);
      });
    }
  }

  configureForStep3(action: tableAction, aliasId?: string) {
    const actions = Object.keys(this.cudActionOrder);

    if (action === tableAction.NEW_RECORD) {
      actions.forEach((act) => {
        const actionOrders = this.cudActionOrder[act];

        const newTablesToInclude = this.tableAliasValue.filter(
          (tav) => !actionOrders.find((actionOrder) => actionOrder.aliasId === tav.aliasId)
        );

        newTablesToInclude.forEach((newTableToInclude) => {
          actionOrders.push({
            aliasId: newTableToInclude.aliasId,
            appId: this.appId,
            table: newTableToInclude.t_tableId,
            action: cudAction.NOACTION,
            alias: newTableToInclude.alias,
            label: `${newTableToInclude.name} (${newTableToInclude.alias})`,
            queryBuilderId: null
            // key: `${newTableToInclude.table}-${newTableToInclude.alias}`,
          });
        });

        this.cudActionOrder[action] = [...actionOrders];
      });
    } else if (action === tableAction.UPDATE_RECORD) {
      actions.forEach((action) => {
        // Find the updated tableAliasValue record
        let updatedTableAlias = this.tableAliasValue.find((tav) => tav.aliasId === aliasId);

        let actionOrders = this.cudActionOrder[action];

        actionOrders.forEach((actionOrder) => {
          if (aliasId === actionOrder.aliasId) {
            actionOrder.label = `${updatedTableAlias.name} (${updatedTableAlias.alias})`;
            actionOrder.alias = updatedTableAlias.alias;
          }
        });
      });
    } else if (
      action === tableAction.DELETE_RECORD ||
      action === tableAction.ACTIVATE_RECORD ||
      action === tableAction.DEACTIVATE_RECORD
    ) {
      actions.forEach((action) => {
        let actionOrders = this.cudActionOrder[action];

        this.cudActionOrder[action] = [...actionOrders.filter((actionOrder) => actionOrder.aliasId !== aliasId)];
      });
    }
  }

  configureNewAliasForStep2(action: tableAction, aliasId?: string) {
    if (this.queryFieldData.length == 0 || this.queryFieldData == null) {
      this.populateQueryFieldData();
    }
    if (action === tableAction.NEW_RECORD) {
      this.queryFieldData.forEach((qfd) => {
        let treeOptions: any[] = [];
        let queryFieldDataType = qfd.type;

        this.tableAliasValue.forEach((ta) => {
          const tableId = ta.table || ta.t_tableId;
          let childrens = this.fieldOptions
            .find((fo) => fo.id === tableId)
            .items.reduce((acc, field) => {
              let fieldType = field.type;
              if (
                (fieldType == queryFieldDataType ||
                  (['Auto-number', 'Number'].includes(queryFieldDataType) &&
                    ['Auto-number', 'Number'].includes(fieldType))) &&
                !GlobalConstants.auditFields.includes(field.name)
              ) {
                acc.push({
                  label: field.name,
                  selectedLabel: `${ta.name} (${ta.alias}) - ${field.name}`,
                  key: `${field.id}-${ta.aliasId}`,
                  aliasId: ta.aliasId,
                  styleClass: 'field-node',
                  data: {
                    appId: this.appId,
                    tfield: field.id,
                    table: tableId,
                    alias: ta.alias
                  }
                });
              }
              return acc;
            }, []);

          if (childrens.length) {
            treeOptions.push({
              aliasId: ta.aliasId,
              label: `${ta.name} (${ta.alias})`,
              alias: ta.alias,
              selectable: false,
              styleClass: 'table-alias-node',
              expanded: true,
              type: 'table',
              children: childrens
            });
          }
        });

        qfd['options'] = treeOptions;
      });
    } else if (action == tableAction.UPDATE_RECORD) {
      // Find the updated tableAliasValue record
      let updatedTableAlias = this.tableAliasValue.find((tav) => tav.aliasId === aliasId);

      // Iterate over the queryFieldData
      this.queryFieldData.forEach((qfd) => {
        // Iterate over the options
        qfd?.options?.forEach((option) => {
          // If the option is tableAliasValue record ie, is updated, then update the label and children alias value
          if (option.aliasId === aliasId) {
            option.alias = updatedTableAlias.alias;
            option.label = `${updatedTableAlias.name} (${updatedTableAlias.alias})`;

            // Iterate over the option children
            option.children.forEach((child) => {
              child.alias = updatedTableAlias.alias;
              child.selectedLabel = `${updatedTableAlias.name} (${updatedTableAlias.alias}) - ${child.label}`;
              child.data.alias = updatedTableAlias.alias;
            });
          }
        });

        // Iterate over the tfield. If any record contains the same uniqueUUID, then update the alias there too
        qfd.tfield?.forEach((tf) => {
          if (tf.aliasId === aliasId) {
            tf.alias = updatedTableAlias.alias;
            tf.selectedLabel = `${updatedTableAlias.name} (${updatedTableAlias.alias}) - ${tf.label}`;
            tf.data.alias = updatedTableAlias.alias;
          }
        });
      });
    } else if (action == tableAction.DELETE_RECORD) {
      // Iterate over the queryFieldData
      this.queryFieldData.forEach((qfd) => {
        // Filter the options, so that deleted tableAliasValue can be removed
        qfd.options = qfd.options?.filter((option) => option && option.aliasId !== aliasId);

        // Filter the tfield, so that any selectedValue can be deselected
        qfd.tfield = qfd.tfield?.filter((tf) => tf && tf.aliasId !== aliasId) ?? null;
      });
    }
  }

  configureNewAliasForStep3(action: tableAction, aliasId?: string) {
    let actions = Object.keys(this.cudActionOrder);

    if (action == tableAction.NEW_RECORD) {
      actions.forEach((action) => {
        let actionOrders = this.cudActionOrder[action];

        let newTablesToInclude = this.tableAliasValue.filter(
          (tav) => !actionOrders.find((actionOrder) => actionOrder.aliasId === tav.aliasId)
        );

        newTablesToInclude.forEach((newTableToInclude) => {
          const tableId = newTableToInclude.table || newTableToInclude.t_tableId;
          actionOrders.push({
            aliasId: newTableToInclude.aliasId,
            appId: this.appId,
            table: tableId,
            action: cudAction.NOACTION,
            alias: newTableToInclude.alias,
            label: `${newTableToInclude.name} (${newTableToInclude.alias})`
            // key: `${newTableToInclude.table}-${newTableToInclude.alias}`,
          });
        });

        this.cudActionOrder[action] = [...actionOrders];
      });
    } else if (action === tableAction.UPDATE_RECORD) {
      actions.forEach((act) => {
        // Find the updated tableAliasValue record
        const updatedTableAlias = this.tableAliasValue.find((tav) => tav.aliasId === aliasId);

        const actionOrders = this.cudActionOrder[act];

        actionOrders.forEach((actionOrder) => {
          if (aliasId === actionOrder.aliasId) {
            actionOrder.label = `${updatedTableAlias.name} (${updatedTableAlias.alias})`;
            actionOrder.alias = updatedTableAlias.alias;
          }
        });
      });
    } else if (
      action === tableAction.DELETE_RECORD ||
      action === tableAction.ACTIVATE_RECORD ||
      action === tableAction.DEACTIVATE_RECORD
    ) {
      actions.forEach((act) => {
        const actionOrders = this.cudActionOrder[act];

        this.cudActionOrder[act] = [...actionOrders.filter((actionOrder) => actionOrder.aliasId !== aliasId)];
      });
    }
  }

  removeField(queryFieldId, fieldIdToDelete) {
    const queryFieldDataObj = this.queryFieldData.find((qfd) => qfd.id === queryFieldId);
    queryFieldDataObj.tfield = queryFieldDataObj.tfield?.filter(
      (tf) => !(tf.data.tfield === fieldIdToDelete.tfield && tf.data.alias === fieldIdToDelete.alias)
    );
    this.cdr.detectChanges();
  }

  isStep2Done() {
    let isDone = false;
    this.queryFieldData.forEach((qfd) => {
      if (qfd.tfield && qfd.tfield.length > 0) {
        isDone = true;
        return;
      }
    });
    return isDone;
  }

  isStep3Done() {
    let isDone = false;
    if (this.tableAliasValue.length) {
      for (const action of this.actionOrder) {
        if (!this.enabledActions?.[action]?.value) {
          isDone = true;
          break;
        }
        const actionRows = this.cudActionOrder?.[action];
        if (!Array.isArray(actionRows)) {
          continue;
        }
        for (const act of actionRows) {
          if (act.action !== cudAction.NOACTION) {
            isDone = true;
            break;
          }
        }
        if (isDone) {
          break;
        }
      }
    }
    return isDone;
  }

  onQueryMapfieldChange(event, column) {
    const eventData = event.node.data;

    // When all the fields under the table are selected, p-treeselect will add the data of parent table along with data of selected fields. In that case remove any table data if included in the tfield.
    column.tfield = column.tfield?.filter((tf) => !tf.type || tf.type !== 'table');

    // Check whether the selected field is part of any other query field's value
    const queryFld = this.queryFieldData?.find((qfd) => {
      if (qfd.id !== column.id) {
        return qfd.tfield?.find((tf) => {
          return tf.data?.alias === eventData?.alias && tf.data?.tfield === eventData?.tfield;
        });
      }
      return false;
    });
    if (queryFld) {
      this.util.showError(
        this.translateService
          .instant('CUD_FLD_DUP')
          .replace('{field1}', this.metaInfoMap[eventData.tfield])
          .replace('{field2}', this.metaInfoMap[queryFld.id])
      );
      const qfldData = this.queryFieldData.map((col) => {
        if (column.id !== col.id) {
          return col;
        }
        const i = col.tfield?.indexOf(eventData.tfield);
        col.tfield?.splice(i, 1);
        return col;
      });
      this.queryFieldData = cloneDeep(qfldData);
    } else {
      this.messageService.clear();
    }

    // Validation for same primary/unique key of different alias of same table mapped with same query field
    let isKeyMappedForSameFieldTwice = false;
    let matchedIndex;
    this.indexMap.forEach((value, key) => {
      value.forEach((idx) => {
        const mappedCount: any[] = [];
        idx.fields.forEach((field) => {
          mappedCount.push(column.tfield.filter((tf) => tf.data.tfield === field).length);
        });
        if (mappedCount.filter((count) => count < 2).length === 0) {
          isKeyMappedForSameFieldTwice = true;
          matchedIndex = idx;
          return;
        }
      });
      if (isKeyMappedForSameFieldTwice) {
        return;
      }
    });
    if (isKeyMappedForSameFieldTwice) {
      if (matchedIndex.fields.length === 1) {
        this.util.showError(
          this.translateService
            .instant('KEY_MAPPED_TWICE_SINGULAR')
            .replace('{Field}', this.metaInfoMap[matchedIndex.fields[0]])
            .replace('{KeyType}', matchedIndex.indexType.toLowerCase())
        );
      } else {
        const fieldNames = matchedIndex.fields.map((field) => {
          return this.metaInfoMap[field];
        });
        this.util.showError(
          this.translateService
            .instant('KEY_MAPPED_TWICE_PLURAL')
            .replace('{CSFields}', fieldNames.slice(0, fieldNames.length - 1).join(', '))
            .replace('{Field}', fieldNames[fieldNames.length - 1])
            .replace('{KeyType}', matchedIndex.indexType.toLowerCase())
        );
      }
      const qfldData = this.queryFieldData.map((col) => {
        if (column.id !== col.id) {
          return col;
        }
        const i = col.tfield?.indexOf(eventData.tfield);
        col.tfield?.splice(i, 1);
        return col;
      });
      this.queryFieldData = cloneDeep(qfldData);
    }
  }

  getSidstep2(qvField) {
    const jsonString = this.globalResults.qvFieldMappings;
    let mappings = [];
    try {
      mappings = JSON.parse(jsonString);
    } catch (e) {
      console.error('Invalid JSON string in globalResults.qvFieldMappings');
      return null;
    }
    const match: any = mappings.find((item: { qvFieldId: string; sid: string }) => item.qvFieldId === qvField);
    return match ? match.sid : null;
  }

  getSidstep3(aliasId: string, actionType): string | null {
    if (!this.globalResults?.qvActions) return null;
    let actionsObj: any;
    try {
      actionsObj = JSON.parse(this.globalResults.qvActions);
    } catch (e) {
      console.error('Invalid JSON in globalResults.qvActions');
      return null;
    }
    const actions = actionsObj[actionType];
    if (!Array.isArray(actions)) return null;
    const match = actions.find((action: any) => action.aliasId === aliasId);
    return match ? match.sid : null;
  }

  newtablealias(tablesid: string): boolean {
    const qvTableAliasesBackup = JSON.parse(this.globalResults?.qvTableAliases || '[]');
    const matching = qvTableAliasesBackup.find((b) => {
      const curraliasId = b.sid;
      return curraliasId === tablesid;
    });
    return !matching;
  }

  getstep1info(field: string, tablesid: string): string {
    const qvTableAliasesBackup = JSON.parse(this.globalResults?.qvTableAliases || '[]');
    const matching = qvTableAliasesBackup.find((b) => {
      const curraliasId = b.sid;
      return curraliasId === tablesid;
    });
    return matching ? matching[field] : '';
  }

  builderchange(id:string,sid:string, qvActionType:string): boolean {

    const qvActionsRawOld = JSON.parse(this.globalResults?.qvActions || '{}');
    if(qvActionType=='INSERT'){
      qvActionType='create'
    }
    else{
      qvActionType=qvActionType.toLowerCase();
    }
    const actions = qvActionsRawOld[qvActionType];
    if (Array.isArray(actions)) {
      const match = actions.find((action: any) => action.aliasId === sid);
      if(match && match.queryBuilderId !== id){
        return true;
      }
    }
    return false;
  }

  private buildQvTableAliases(stepPayload: any, isCreate: boolean): string {
    return JSON.stringify(
      (JSON.parse(stepPayload.t_cud_qv_tables) || []).map((item) => {
        const aliasObj = JSON.parse(item.alias);
        return {
          appId: item.appId,
          tableId: this.currentTableId,
          t_tableId: item.table,
          sid: aliasObj.sid,
          orgId: this.orgId,
          createdBy: isCreate
            ? ''
            : this.newtablealias(aliasObj.sid)
              ? ''
              : this.getstep1info('createdBy', aliasObj.sid),
          createdDate: isCreate
            ? ''
            : this.newtablealias(aliasObj.sid)
              ? ''
              : this.getstep1info('createdDate', aliasObj.sid),
          modifiedBy: isCreate
            ? ''
            : this.newtablealias(aliasObj.sid)
              ? ''
              : this.getstep1info('modifiedBy', aliasObj.sid),
          modifiedDate: isCreate
            ? ''
            : this.newtablealias(aliasObj.sid)
              ? ''
              : this.getstep1info('modifiedDate', aliasObj.sid),
          hasChange: isCreate ? false : (item.hasChange ?? false),
          newConfig: isCreate ? true : this.newtablealias(aliasObj.sid),
          type: 'TABLE_ALIAS',
          aliasName: aliasObj.name || '',
          indexSid: item.indexSid || null
        };
      })
    );
  }

  newqvField(qvField: string): boolean {
    const qvFieldMappingsbackup = JSON.parse(this.globalResults?.qvFieldMappings || '[]');
    const matching = qvFieldMappingsbackup.find((b) => b.qvFieldId === qvField);
    if (matching) {
      return false;
    }
    return true;
  }

  getstep2info(field: string, qvField: string): string {
    const qvFieldMappingsbackup = JSON.parse(this.globalResults?.qvFieldMappings || '[]');
    const matching = qvFieldMappingsbackup.find((b) => b.qvFieldId === qvField);
    return matching ? matching[field] : '';
  }

  private buildQvFieldMappings(stepPayload: any, isCreate: boolean): string {
    const rawFieldMappings = JSON.parse(stepPayload.t_cud_qv_mapping || '{}');
    const currentRecordIdentifierLookup = this.getCurrentRecordIdentifierLookup();
    const savedRecordIdentifierLookup = this.getSavedRecordIdentifierLookup();
    const existingFieldMappings = JSON.parse(this.globalResults?.qvFieldMappings || '[]');
    const existingFieldMappingMap = new Map<string, any[]>(
      existingFieldMappings.map((item: any) => [item.qvFieldId, item.fieldMapping || []])
    );

    return JSON.stringify(
      Object.entries(rawFieldMappings).flatMap(([qvField, mappings]: [string, any[]]) => {
        if (!Array.isArray(mappings) || mappings.length === 0) return [];
        const first = mappings[0];
        const savedMappings = existingFieldMappingMap.get(qvField) || [];
        const isExistingQvField = existingFieldMappingMap.has(qvField);
        const fieldMapping = mappings.map((m) => {
          const aliasObj = this.parseAliasValue(m.alias);
          return {
            aliasId: aliasObj.sid || '',
            tableId: m.table || '',
            fieldId: m.tfield || '',
            uniqueIdGenReq: m.uniqueIdGenReq || false,
            indexSid: this.getIndexSidForFieldMapping(m, currentRecordIdentifierLookup, aliasObj.sid)
          };
        });

        return [
          {
            appId: first.appId || '',
            tableId: this.currentTableId,
            sid: isCreate ? uuidv4() : this.getSidstep2 ? (this.getSidstep2(qvField) ?? uuidv4()) : uuidv4(),
            orgId: this.orgId,
            createdBy: isCreate ? '' : this.newqvField(qvField) ? '' : this.getstep2info('createdBy', qvField),
            createdDate: isCreate ? '' : this.newqvField(qvField) ? '' : this.getstep2info('createdDate', qvField),
            modifiedBy: isCreate ? '' : this.newqvField(qvField) ? '' : this.getstep2info('modifiedBy', qvField),
            modifiedDate: isCreate ? '' : this.newqvField(qvField) ? '' : this.getstep2info('modifiedDate', qvField),
            hasChange: isCreate
              ? false
              : !isExistingQvField
                ? false
                : !this.areFieldMappingsEquivalent(
                    fieldMapping,
                    currentRecordIdentifierLookup,
                    savedMappings,
                    savedRecordIdentifierLookup
                  ),
            newConfig: isCreate ? true : !isExistingQvField,
            type: 'FIELD_MAPPING',
            qvFieldId: qvField,
            fieldMapping
          }
        ];
      })
    );
  }

  private actionreorder(qvActionType: string): boolean {
    return this.reorderActions.includes(qvActionType.toLowerCase());
  }

  callApi(stepPayload, ignoreWarn, isConfigClearCall = false, isFromQueryBuilder = false, reset) {
    console.log('steppayload ', stepPayload);
    if (this.create) {
      const qvTableAliases = this.buildQvTableAliases(stepPayload, this.create);
      const qvFieldMappings = this.buildQvFieldMappings(stepPayload, this.create);

      const qvActionsRawOld = JSON.parse(stepPayload.t_cud_qv_action_order || '{}');

      const createActionObjects = (actionList = [], qvActionType: string) => {
        return (actionList || []).map((item: any, index: number) => {
          const alias = JSON.parse(item.alias || '{}');
          const isDisabled =
            Array.isArray(qvActionsRawOld.disabled) && qvActionsRawOld.disabled.includes(item.qvAction);
          return {
            appId: item.appId,
            action: item.action || 'NO_ACTION',
            qvAction: qvActionType,
            tableId: this.currentTableId,
            t_tableId: item.table,
            sid: uuidv4(),
            aliasId: alias.sid,
            orgId: this.orgId,
            createdBy: '',
            createdDate: '',
            modifiedBy: '',
            modifiedDate: '',
            disabled: isDisabled,
            hasChange: false,
            newConfig: true,
            type: 'ACTION',
            actionOrder: index + 1,
            queryBuilderId: item.queryBuilderId || null
          };
        });
      };

      const qvActionsRaw = [
        ...createActionObjects(qvActionsRawOld.create, 'INSERT'),
        ...createActionObjects(qvActionsRawOld.update, 'UPDATE'),
        ...createActionObjects(qvActionsRawOld.delete, 'DELETE'),
        ...(this.isDeactivateRecords ? createActionObjects(qvActionsRawOld.activate, 'ACTIVATE') : []),
        ...(this.isDeactivateRecords ? createActionObjects(qvActionsRawOld.deactivate, 'DEACTIVATE') : [])
      ];
      const qvActionsObj = {
        disabled: qvActionsRawOld.disabled,
        create: qvActionsRaw.filter((item) => item.qvAction === 'INSERT'),
        update: qvActionsRaw.filter((item) => item.qvAction === 'UPDATE'),
        delete: qvActionsRaw.filter((item) => item.qvAction === 'DELETE'),
        ...(this.isDeactivateRecords && {
          activate: qvActionsRaw.filter((item) => item.qvAction === 'ACTIVATE'),
          deactivate: qvActionsRaw.filter((item) => item.qvAction === 'DEACTIVATE')
        })
      };
      const qvActions: string = JSON.stringify(qvActionsObj);

      this.payload = {
        tableId: this.currentTableId,
        appId: this.appId,
        qvTableAliases: qvTableAliases,
        qvFieldMappings: qvFieldMappings,
        qvActions: qvActions
      };

      const url = `${ApiConstants.createCud.url}?${new HttpParams().append('ignoreWarnings', ignoreWarn)}`;
      const apiObj = { ...ApiConstants.createCud, ...{ url: url } };
      this.isLoading = true;
      let sub = this.baseService.post(apiObj, this.payload).subscribe(
        (results: any) => {
          this.isLoading = false;
          if (results) {
            if (results.PREVALIDATIONS) {
              let err = results.PREVALIDATIONS;

              this.isLoading = true;
              // setTimeout is required to allow metainfo to be updated with the lastest alias tables
              setTimeout(() => {
                this.isLoading = false;
                this.openCudPreValidationModal(err);
              }, 1000);
              this.errorData = cloneDeep(err);
              this.payload = stepPayload;
            } else {
              this.backupData = {
                ...stepPayload
              };
              if (this.activeIndex == 2 && !isFromQueryBuilder && !reset) {
                this.showCudConfig = false;
              }
              if (reset) {
                this.util.showMessage('success', this.translateService.instant('CUD_ACTION_CHANGE'));
              } else {
                this.create = false;
                this.modelValue = stepPayload.t_cud_qv_tables;
                this.writeValue(this.modelValue);
                this.util.showMessage('success', this.translateService.instant('CUD_SUCC_SAVED'));
              }
            }
          }
        },
        (err: any) => {
          this.isLoading = false;
        }
      );
      this.addToSubscriptionsList(sub);
    } else {
      const qvTableAliases = this.buildQvTableAliases(stepPayload, this.create);
      const qvFieldMappings = this.buildQvFieldMappings(stepPayload, this.create);

      const qvActionsRawOld = JSON.parse(stepPayload.t_cud_qv_action_order || '{}');
      const buildQvActions = (actionList: any[] = [], qvActionType: string, sidActionType: string) => {
        return (actionList || []).map((item, index) => {
          const alias = JSON.parse(item.alias || '{}');
          let sid = this.getSidstep3(alias.sid, sidActionType);
          let isNewConfig = false;
          if (!sid) {
            sid = uuidv4();
            isNewConfig = true;
          }
          const isDisabled =
            Array.isArray(qvActionsRawOld.disabled) && qvActionsRawOld.disabled.includes(item.qvAction);
          return {
            appId: item.appId,
            action: item.action || 'NO_ACTION',
            qvAction: qvActionType,
            tableId: this.currentTableId,
            t_tableId: item.table,
            sid: sid,
            aliasId: alias.sid,
            orgId: this.orgId,
            createdBy: isNewConfig ? '' : this.getstep3info('createdBy', sid ?? ''),
            createdDate: isNewConfig ? '' : this.getstep3info('createdDate', sid ?? ''),
            modifiedBy: isNewConfig ? '' : this.getstep3info('modifiedBy', sid ?? ''),
            modifiedDate: isNewConfig ? '' : this.getstep3info('modifiedDate', sid ?? ''),
            disabled: isDisabled,
            hasChange: isNewConfig
              ? false
              : (!item.hasChange ? (!this.disabledchange(qvActionsRawOld.disabled, qvActionType)
              ? (this.actionreorder(qvActionType) ? true
                : this.builderchange(item.queryBuilderId,alias.sid , qvActionType)? true : false)
                : true)
                : item.hasChange),
            newConfig: isNewConfig,
            type: 'ACTION',
            actionOrder: index + 1,
            queryBuilderId: item.queryBuilderId || null
          };
        });
      };

      const qvActionsRaw = [
        ...buildQvActions(qvActionsRawOld.create, 'INSERT', 'create'),
        ...buildQvActions(qvActionsRawOld.update, 'UPDATE', 'update'),
        ...buildQvActions(qvActionsRawOld.delete, 'DELETE', 'delete'),
        ...(this.isDeactivateRecords ? buildQvActions(qvActionsRawOld.activate, 'ACTIVATE', 'activate') : []),
        ...(this.isDeactivateRecords ? buildQvActions(qvActionsRawOld.deactivate, 'DEACTIVATE', 'deactivate') : [])
      ];
      const qvActionsObj = {
        disabled: qvActionsRawOld.disabled,
        create: qvActionsRaw.filter((item) => item.qvAction === 'INSERT'),
        update: qvActionsRaw.filter((item) => item.qvAction === 'UPDATE'),
        delete: qvActionsRaw.filter((item) => item.qvAction === 'DELETE'),
        ...(this.isDeactivateRecords && {
          activate: qvActionsRaw.filter((item) => item.qvAction === 'ACTIVATE'),
          deactivate: qvActionsRaw.filter((item) => item.qvAction === 'DEACTIVATE')
        })
      };
      const qvActions: string = JSON.stringify(qvActionsObj);

      const oldTables = JSON.parse(this.globalResults?.qvTableAliases || '[]');
      const newTables = JSON.parse(stepPayload.t_cud_qv_tables || '[]');

      const oldQvFieldMappings = JSON.parse(this.globalResults?.qvFieldMappings || '[]');
      const newQvFieldMappings = JSON.parse(this.buildQvFieldMappings(stepPayload, this.create) || '[]');

      const newQvFieldMappingsSidSet = new Set(newQvFieldMappings.map((o) => o.sid));
      const deletedQvFieldMappings = oldQvFieldMappings.filter((o) => !newQvFieldMappingsSidSet.has(o.sid));

      const deletedTableAliasesId = JSON.stringify(
        oldTables
          .filter((oldItem) => {
            return (
              oldItem?.sid &&
              !newTables.some((newItem) => {
                let aliasObj;
                try {
                  aliasObj = JSON.parse(newItem.alias);
                } catch {
                  aliasObj = {};
                }
                return aliasObj.sid === oldItem.sid;
              })
            );
          })
          .map((item) => ({
            appId: item.appId,
            tableId: this.currentTableId,
            t_tableId: item.table || item.t_tableId,
            sid: item.sid,
            orgId: this.orgId,
            aliasId: item.sid,
            createdBy: '',
            createdDate: '',
            modifiedBy: '',
            modifiedDate: '',
            hasChange: true,
            newConfig: true,
            type: 'TABLE_ALIAS',
            aliasName: item.aliasName || ''
          }))
      );

      this.payload = {
        tableId: this.currentTableId,
        appId: this.appId,
        qvTableAliases: qvTableAliases,
        qvFieldMappings: qvFieldMappings,
        qvActions: qvActions,
        deletedTableAliases: deletedTableAliasesId,
        deletedQvFieldMappings:JSON.stringify(deletedQvFieldMappings)
      };
      const url = `${ApiConstants.updateCud.url}?${new HttpParams().append('ignoreWarnings', ignoreWarn)}`;
      const apiObj = { ...ApiConstants.updateCud, ...{ url: url } };
      this.isLoading = true;
      let sub = this.baseService.put(apiObj, this.payload).subscribe(
        (results: any) => {
          this.isLoading = false;
          if (results) {
            if (results.PREVALIDATIONS) {
              let err = results.PREVALIDATIONS;
              this.isLoading = true;
              // setTimeout is required to allow metainfo to be updated with the lastest alias tables
              setTimeout(() => {
                this.isLoading = false;
                this.openCudPreValidationModal(err);
              }, 1000);
              this.errorData = cloneDeep(err);
              this.payload = stepPayload;
            } else {
              this.backupData = {
                ...stepPayload
              };
              if (this.activeIndex == 2 && !isFromQueryBuilder && !reset) {
                this.showCudConfig = false;
              }
              if (!isConfigClearCall) {
                this.modelValue = stepPayload.t_cud_qv_tables;
                this.writeValue(this.modelValue);
                this.util.showMessage('success', this.translateService.instant('CUD_SUCC_SAVED'));
              }
            }
          }
        },
        (err: any) => {
          this.isLoading = false;
        }
      );
      this.addToSubscriptionsList(sub);
    }
  }

  areFieldMappingsEqual(newFieldMapping, oldFieldMapping) {
    if (newFieldMapping.length !== oldFieldMapping.length) return false;

  const makeKey = m => `${m.aliasId}-${m.tableId}-${m.fieldId}`;

    const newFieldMappingset = new Set(newFieldMapping.map(makeKey));

    for (const map of oldFieldMapping) {
      if (!newFieldMappingset.has(makeKey(map))) return false;
    }

    return true;
  }


  getstep3info(field: string, actionSid: string): string {
    if (!this.globalResults?.qvActions) return '';
    let actionsObj: any;
    try {
      actionsObj = JSON.parse(this.globalResults.qvActions);
    } catch (e) {
      return '';
    }
    const safeArray = (arr: any) => (Array.isArray(arr) ? arr.filter((x) => x && typeof x === 'object') : []);
    const allActions = [
      ...safeArray(actionsObj.create),
      ...safeArray(actionsObj.update),
      ...safeArray(actionsObj.delete),
      ...(this.isDeactivateRecords ? safeArray(actionsObj.activate) : []),
      ...(this.isDeactivateRecords ? safeArray(actionsObj.deactivate) : [])
    ];
    const match = allActions.find((b: any) => b && b.sid === actionSid);
    return match && field in match ? match[field] : '';
  }

  disabledchange(newDisabledArr: string[], action: string): boolean {
    let oldDisabledArr: string[] = [];
    try {
      const qvActions = JSON.parse(this.globalResults.qvActions || '{}');
      oldDisabledArr = Array.isArray(qvActions.disabled) ? qvActions.disabled : [];
    } catch {
      oldDisabledArr = [];
    }
    const added = newDisabledArr.filter((x) => !oldDisabledArr.includes(x));
    const removed = oldDisabledArr.filter((x) => !newDisabledArr.includes(x));
    if (added.includes(action) || removed.includes(action)) {
      return true;
    }
    return false;
  }

  deleteCudConfig() {
    const confirmDeleteCallback = () => {
      this.clearCudConfig();
    };
    this.confirmationDialogService.confirm({
      message: this.translateService.instant('CUD_DELETE_CONFIRMATION'),
        header: this.translateService.instant('CONFIRMATION'),
      accept: confirmDeleteCallback,
      reject: () => {
        return;
      }
    });
  }

  clearCudConfig() {
    this.isLoading = true;
    this.setValueToSteps();
    this.tableAliasValue = [];
    this.fieldTOptions = [];
    this.fieldOptions = [];
    this.queryFieldData = [];
    this.cudActionOrder = {
      create: [],
      update: [],
      delete: [],
      ...(this.isDeactivateRecords && { activate: [], deactivate: [] })
    };
    this.enabledActions = {
      create: { name: 'ACT_CREATE', value: true, keyName: cudAction.INSERT },
      update: { name: 'ACT_UPD', value: true, keyName: cudAction.UPDATE },
      delete: { name: 'ACT_DEL', value: true, keyName: cudAction.DELETE }
    };
    if (this.isDeactivateRecords) {
      // eslint-disable-next-line dot-notation
      this.enabledActions['activate'] = { name: 'ACT_ACTIVATE', value: true, keyName: cudAction.ACTIVATE };
      // eslint-disable-next-line dot-notation
      this.enabledActions['deactivate'] = { name: 'ACT_DEACTIVATE', value: true, keyName: cudAction.DEACTIVATE };
    }
    const payload = {
      t_cud_qv_tables: null,
      t_cud_qv_action_order: null,
      t_cud_qv_mapping: null,
      old_t_cud_qv_tables: this.formData?.t_cud_qv_tables,
      old_t_cud_qv_mapping: this.formData?.t_cud_qv_mapping
    };
    const deleteSub = this.baseService.delete(ApiConstants.deleteCud, { tableId: this.currentTableId }).subscribe({
      next: () => {
        this.util.showMessage('success', this.translateService.instant('CUD_SUCC_DELETED'));
        this.create = true;
        this.isLoading = false;
        this.showCudConfig = false;
      },
      error: (err) => {
        this.util.showMessage('error', this.translateService.instant('CUD_ERR_DELETED'));
        this.isLoading = false;
        this.showCudConfig = false;
      }
    });

    this.addToSubscriptionsList(deleteSub);
    this.callApi(payload, false, true, false, false);
  }

  formDataForSave() {
    const aliasMap = new Map();
    const currentRecordIdentifierLookup = this.getCurrentRecordIdentifierLookup();
    const savedRecordIdentifierLookup = this.getSavedRecordIdentifierLookup();
    this.tableAliasValue.forEach((tav) => {
      aliasMap.set(
        tav.alias,
        JSON.stringify({
          name: tav.alias,
          sid: tav.aliasId
        })
      );
    });

    // form data for step1
    this.fieldTOptions = cloneDeep(this.fieldOptions);
    let data = {};
    if (this.tableAliasValue.length) {
      const qvTableAliasesBackup = JSON.parse(this.globalResults?.qvTableAliases || '[]');
      data = {
        t_cud_qv_tables: JSON.stringify(
          this.tableAliasValue.map((ta) => {
            const aliasStr = aliasMap.get(ta.alias);
            const payload = {
              appId: this.appId,
              table: ta.table || ta.t_tableId,
              alias: aliasStr,
              indexSid: ta.indexSid || null
            };
            const aliasObj = JSON.parse(aliasStr);
            const tableMatch = qvTableAliasesBackup.find((b) => {
              const tableId = b.table || b.t_tableId;
              return tableId === payload.table && b?.sid === aliasObj.sid;
            });
            if (tableMatch) {
              if (tableMatch.aliasName !== aliasObj.name || tableMatch.indexSid !== ta.indexSid) {
                payload['hasChange'] = true;
              }
            }
            return payload;
          })
        )
      };
    }

    // form data for step2
    let qvMapping: Record<string, any[]> = {};
    const qvMappingBackup = JSON.parse(this.globalResults?.qvFieldMappings || '[]');
    const qvMappingBackupMap = new Map<string, any[]>(
      qvMappingBackup.map((item: any) => [item.qvFieldId, item.fieldMapping || []])
    );
    this.queryFieldData.forEach((q) => {
      if (q?.tfield && q?.tfield?.length > 0) {
        qvMapping[q.id] = q.tfield.map((tf) => {
          const aliasStr = aliasMap.get(tf?.data.alias);
          return {
            ...tf?.data,
            alias: aliasStr,
            uniqueIdGenReq: q.uniqueIdGenReq ?? false,
            indexSid: this.getIndexSidForFieldMapping(
              { ...tf?.data, alias: aliasStr },
              currentRecordIdentifierLookup
            )
          };
        });

        if (!this.create) {
          const matchingBackupList = qvMappingBackupMap.get(q.id) || [];
          const hasChange = !this.areFieldMappingsEquivalent(
            qvMapping[q.id],
            currentRecordIdentifierLookup,
            matchingBackupList,
            savedRecordIdentifierLookup
          );
          this.mappingsChange[q.id] = hasChange;
        }
      }
    });
    data = {
      ...data,
      ...{
        t_cud_qv_mapping: Object.keys(qvMapping).length ? JSON.stringify({ ...qvMapping }) : null
      }
    };

    // form data for step3
    let disAcs = Object.keys(this.enabledActions)
      .filter((a) => !this.enabledActions[a]?.value)
      .map((disAct) => this.enabledActions[disAct]?.keyName);
    if (
      this.isDeactivateRecords ||
      this.cudActionOrder.create.length ||
      this.cudActionOrder.update.length ||
      this.cudActionOrder.delete.length
    ) {
      const actionOrderPayload: any = {};
      const cudBackup = JSON.parse(this.globalResults?.qvActions || '{}');
      const allActionTypes = ['create', 'update', 'delete'];
      if (this.isDeactivateRecords) {
        allActionTypes.push('activate', 'deactivate');
      }
      allActionTypes.forEach((type) => {
        const mapped = this.mapActionsForSave(type, aliasMap);
        const backupList = cudBackup[type] || [];

        actionOrderPayload[type] = mapped.map((m) => {
          const aliasObj = m.alias ? JSON.parse(m.alias) : {};
          const original = backupList.find((b) => (b?.aliasId) === aliasObj.sid);
          if (original) {
            const isSame = original.action === m.action;
            if (isSame == false) {
              return { ...m, hasChange: true };
            }
          }
          return m;
        });
      });
      data = {
        ...data,
        ...{
          t_cud_qv_action_order: JSON.stringify({
            ...{ disabled: disAcs },
            ...actionOrderPayload
          })
        }
      };
    }
    return data;
  }

  onActionFocus(oldAction) {
    this.oldAction = oldAction;
  }

  resetQbId(event, value, action) {
    if (value['queryBuilderId']) {
      let referenceDeleteSid = `${this.appGlobalService.get('appId')}_$_${value['sid']}_$_${this.appGlobalService.get('appId')}_$_${value['queryBuilderId']}$_$QUERY_BUILDER`;
      this.callDeleteReferences(referenceDeleteSid);
      value['queryBuilderId'] = null;
      this.cudActionOrder[action].forEach((a) => {
        if (value['aliasId'] == a?.aliasId && value?.table == a?.table) {
          a['queryBuilderId'] = null;
          a['action'] = value?.action;
        }
      });
      this.cdr.detectChanges();
    }
  }

  mapActionsForSave(actionName: any, aliasMap: any) {
    return (
      this.cudActionOrder[actionName]?.map((action) => {
        return {
          appId: action.appId,
          action: action.action,
          table: action.table,
          alias: aliasMap.get(action.alias),
          queryBuilderId: action?.queryBuilderId
        };
      }) || []
    );
  }

  isNewDataForSave() {
    const stepPayload: any = this.formDataForSave();
    const isDirty =
      this.backupData &&
      (((this.backupData.t_cud_qv_tables || stepPayload?.t_cud_qv_tables) &&
        !isEqual(this.backupData.t_cud_qv_tables, stepPayload.t_cud_qv_tables)) ||
        ((this.backupData.t_cud_qv_mapping || stepPayload?.t_cud_qv_mapping) &&
          !isEqual(this.backupData.t_cud_qv_mapping, stepPayload?.t_cud_qv_mapping)) ||
        ((this.backupData.t_cud_qv_action_order || stepPayload?.t_cud_qv_action_order) &&
          !isEqual(this.backupData.t_cud_qv_action_order, stepPayload.t_cud_qv_action_order)));
    return isDirty;
  }

  isNewData() {
    let data: any = this.formDataForSave();
    if (
      this.step1Valueschange(JSON.parse(data?.t_cud_qv_tables || '[]')) ||
      this.step2Valueschange(JSON.parse(data?.t_cud_qv_mapping || '{}')) ||
      this.step3Valueschange(JSON.parse(data?.t_cud_qv_action_order || '{}')) ||
      this.reorderActions.length > 0
    ) {
      return true;
    }
    return false;
  }
  step1Valueschange(tablesvalues: any): boolean {
    type BackupItem = { sid?: string; aliasName?: string; indexSid?: string };
    const backup: BackupItem[] = JSON.parse(this.globalResults?.qvTableAliases || '[]');
    if ((!backup || backup.length === 0) && (!tablesvalues || tablesvalues.length === 0)) {
      return false;
    }
    if ((backup?.length || 0) !== (tablesvalues?.length || 0)) {
      return true;
    }
    for (let i = 0; i < tablesvalues.length; i++) {
      const t = tablesvalues[i];
      const aliasObj: { sid?: string; name?: string } = t.alias ? JSON.parse(t.alias) : {};
      const match = backup.find((b) => b?.sid === aliasObj?.sid && b?.aliasName === aliasObj?.name && (b?.indexSid || null) === (t.indexSid || null));
      if (!match) {
        return true;
      }
    }
    return false;
  }

  step2Valueschange(mappings: any): boolean {
    const backup = JSON.parse(this.globalResults?.qvFieldMappings || '[]');
    const currentRecordIdentifierLookup = this.getCurrentRecordIdentifierLookup();
    const savedRecordIdentifierLookup = this.getSavedRecordIdentifierLookup();
    if ((!backup || backup.length === 0) && (!mappings || Object.keys(mappings).length === 0)) {
      return false;
    }
    if ((backup?.length || 0) !== (Object.keys(mappings).length || 0)) {
      return true;
    }
    for (const qvFieldId of Object.keys(mappings || {})) {
      const mappedArr = mappings[qvFieldId] || [];
      const backupItem = backup.find((b) => b.qvFieldId === qvFieldId);
      if (!backupItem) {
        return true;
      }
      const backupArr = backupItem.fieldMapping || [];
      if (!this.areFieldMappingsEquivalent(mappedArr, currentRecordIdentifierLookup, backupArr, savedRecordIdentifierLookup)) {
        return true;
      }
    }
    return false;
  }

  step3Valueschange(actionlist: any): boolean {
    const backup = JSON.parse(this.globalResults?.qvActions || '{}');
    if ((!backup || Object.keys(backup).length === 0) && (!actionlist || Object.keys(actionlist).length === 0)) {
      return false;
    }
    const backupDisabled = Array.isArray(backup.disabled) ? backup.disabled : [];
    const currentDisabled = Array.isArray(actionlist.disabled) ? actionlist.disabled : [];
    if (
      backupDisabled.length !== currentDisabled.length ||
      backupDisabled.some((d) => !currentDisabled.includes(d)) ||
      currentDisabled.some((d) => !backupDisabled.includes(d))
    ) {
      return true;
    }
    const actionTypes = Object.keys(actionlist).filter((k) => k !== 'disabled');
    for (const type of actionTypes) {
      const currentArr = Array.isArray(actionlist[type]) ? actionlist[type] : [];
      const backupArr = Array.isArray(backup[type]) ? backup[type] : [];
      if (currentArr.length !== backupArr.length) {
        return true;
      }
      for (let i = 0; i < currentArr.length; i++) {
        const curr = currentArr[i];
        const currAliasObj = curr.alias ? JSON.parse(curr.alias) : {};
        const backupMatch = backupArr.find((b) => {
          const bAliasObj = b.alias ? JSON.parse(b.alias) : {};
          return (
            (b.table || b.t_tableId) === curr.table &&
            b.action === curr.action &&
            (bAliasObj.sid || b.aliasId) === (currAliasObj.sid || curr.aliasId)
          );
        });
        if (!backupMatch) {
          return true;
        }
      }
      for (const b of backupArr) {
        const bAliasObj = b.alias ? JSON.parse(b.alias) : {};
        const found = currentArr.find((curr) => {
          const currAliasObj = curr.alias ? JSON.parse(curr.alias) : {};
          return (
            (b.table || b.t_tableId) === curr.table &&
            b.action === curr.action &&
            (bAliasObj.sid || b.aliasId) === (currAliasObj.sid || curr.aliasId)
          );
        });
        if (!found) {
          return true;
        }
      }
    }
    return false;
  }

  stepSave(isFromQueryBuilder = false) {
    if (this.tableAliasValue.length === 0) {
      this.clearCudConfig();
    } else {
      let stepPayload: any = this.formDataForSave();
      // trigger api if there is a change in payload
      if (this.isNewDataForSave()) {
        if (this.backupData?.t_cud_qv_tables) {
          // send old data if there is a change
          if (!isEqual(this.backupData.t_cud_qv_tables, stepPayload.t_cud_qv_tables)) {
            stepPayload = {
              ...stepPayload,
              ...{
                old_t_cud_qv_tables: this.backupData.t_cud_qv_tables
              }
            };
          }
        } else {
          // send old data as empty string for first save
          stepPayload = {
            ...stepPayload,
            ...{
              old_t_cud_qv_tables: ''
            }
          };
        }
        // form data for step2
        if (this.backupData?.t_cud_qv_mapping) {
          // send old data if there is a change
          if (!isEqual(this.backupData.t_cud_qv_mapping, stepPayload?.t_cud_qv_mapping)) {
            stepPayload = {
              ...stepPayload,
              ...{
                old_t_cud_qv_mapping: this.backupData.t_cud_qv_mapping
              }
            };
          }
        } else {
          // send old data as empty string for first save
          stepPayload = {
            ...stepPayload,
            ...{
              old_t_cud_qv_mapping: ''
            }
          };
        }
        this.callApi(stepPayload, false, false, isFromQueryBuilder, false);
      }
    }
  }

  initializeTableOrders() {
    const tree = $.ui.fancytree.getTree('#tree');
    this.tableOrders = tree.rootNode?.children;
  }

  checkConcurrency() {
    this.allTableData = [];
    this.initializeTableOrders();
    this.getAllTableData(this.tableOrders);
    this.tableOptions = [
      ...this.allTableData
        .filter(
          (node) => node?.data?.t_type === DMConstants.TRANS_ONLY || node?.data?.t_type === DMConstants.TRANS_ANALY
        )
        .map((d) => {
          return {
            name: d.title,
            id: d.key
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name))
    ];
    this.fieldOptions = [
      ...this.tableOptions
        .map((t) => {
          return {
            name: t.name,
            id: t.id,
            items: [
              ...this.allTableData
                .filter((d) => d.key === t.id)[0]
                .children.map((k) => {
                  this.tableMap = { ...this.tableMap, ...{ [k.key]: t.name } };
                  return {
                    name: k.title,
                    id: k.key,
                    type: k.data.f_type
                  };
                })
                .sort((a, b) => a.name.localeCompare(b.name))
            ]
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name))
    ];
    const deletedTable: any[] = [];
    const deletedField: any[] = [];
    const updatedField: any[] = [];
    const updatedTable: any[] = [];

    this.tableAliasValue.forEach((tav) => {
      const tableId = tav.table || tav.t_tableId;
      if (!this.allTableData.find((a) => a.key == tableId)) {
        deletedTable.push({
          name: this.metaInfoMap[tableId],
          id: tableId
        });
        const dFieldsList = this.fieldTOptions.find((f) => f.id === tableId)
          ? [
              ...(this.fieldTOptions
                ?.filter((f) => f.id === tableId)[0]
                ?.items?.map((i) => {
                  return i.id;
                }) ?? [])
            ]
          : [];
        if (dFieldsList.length > 0) {
          this.queryFieldData.find((q) =>
            q?.tfield?.forEach((t) => {
              if (dFieldsList.includes(t)) {
                deletedField.push({
                  name: this.metaInfoMap[t],
                  id: t
                });
                return false;
              }
              return true;
            })
          );
        }
        if (
          this.allTableData.find((a) => a.key === tableId)?.data?.t_type !== DMConstants.TRANS_ONLY &&
          this.allTableData.find((a) => a.key === tableId)?.data?.t_type !== DMConstants.TRANS_ANALY
        ) {
          updatedTable.push({
            sid: tableId,
            name: this.metaInfoMap[tableId]
          });
        }
      }
    });
    this.fieldTOptions = cloneDeep(this.fieldOptions);
    this.queryFieldData.forEach((q) => {
      if (q?.tfield) {
        q?.tfield?.forEach((tf) => {
          // Setting Field ID in t
          const t = tf?.data.tfield;
          let tfieldType;
          let tbId;
          this.fieldTOptions.forEach((o) => {
            o.items.forEach((i) => {
              if (i.id === t) {
                tfieldType = i.type;
                tbId = o.id;
                return;
              }
            });
          });
          if (tfieldType && tfieldType !== q?.type) {
            updatedField.push({
              name: this.metaInfoMap[t],
              id: t
            });
            return false;
          }
          if (!tbId) {
            deletedField.push({
              name: this.metaInfoMap[t],
              id: t
            });
            return false;
          }
          return true;
        });
      }
    });
    let message = '';
    if (deletedTable.length > 0) {
      message += this.translateService
        .instant('CUD_TBL_DEL')
        .replace('{table}', deletedTable.map((v) => v.name).join(', '));
      this.tableValue = [...this.tableValue.filter((t) => !deletedTable.find((d) => d.id === t.id))];
    }
    if (deletedField.length > 0) {
      message += this.translateService
        .instant('CUD_FLD_DEL')
        .replace('{field}', deletedField.map((v) => v.name).join(', '));
    }
    if (updatedTable.length > 0) {
      message += this.translateService
        .instant('CUD_TBL_UPD')
        .replace('{table}', updatedTable.map((v) => v.name).join(', '));
      this.tableValue = [...this.tableValue.filter((t) => !updatedTable.find((d) => d.id === t.id))];
    }
    if (updatedField.length > 0) {
      message += this.translateService
        .instant('CUD_FLD_UPD')
        .replace('{field}', updatedField.map((v) => v.name).join(', '));
    }
    if (message) {
      this.confirmationDialogService.confirm({
        message: message,
        acceptLabel: this.translateService.instant('CONTINUE'),
        rejectVisible: false,
        accept: () => {
          this.stepSave();
        }
      });
    } else {
      this.stepSave();
    }
  }

  prevStep() {
    this.activeIndex -= 1;
  }

  nextStep() {
    this.activeIndex += 1;
  }

  handleTabChange(e) {
    this.activeIndex = e.index;
  }

  onReorder(event, action) {
    if (!this.reorderActions) {
      this.reorderActions = [];
    }
    if (action) {
      if (action === 'create') {
        this.reorderActions.push('insert');
      } else {
        this.reorderActions.push(action);
      }
    }
  }

  areFieldsAvailable() {
    return !!this.allTableData.filter((d) => d.key === this.currentTableId)[0]?.children?.length;
  }

  openCudConfig() {
    if (!this.areFieldsAvailable()) {
      this.messageService.add({
        life: 10000,
        severity: 'error',
        summary: this.translateService.instant('ADD_QUERY_FIELDS_SUMMARY'),
        detail: this.translateService.instant('ADD_QUERY_FIELDS_DETAIL')
      });
      return;
    }
    this.showCudConfig = true;
    this.isLoading = true;
    this.showQueryBuilder = false;
    this.activeIndex = 0;
    if (!this.fieldOptions || (this.fieldOptions && this.fieldOptions.length === 0)) {
      this.constructFieldOptions();
    }

    const sub = this.baseService.get(ApiConstants.getCud, { tableId: this.currentTableId }).subscribe(
      (results: any) => {
        this.isLoading = false;
        if (!results || (results.qvTableAliases === '' && results.qvFieldMappings === '' && results.qvActions === '')) {
          this.create = true;
        } else {
          this.create = false;
          this.setValueToSteps(results);
        }
      },
      (err: any) => {
        this.isLoading = false;
        console.log(err);
      }
    );
    this.addToSubscriptionsList(sub);
  }

  getAllTableData(datamodelOrder) {
    datamodelOrder.forEach((node) => {
      if (!node.title) {
        return;
      }
      if (node.type === nodeType.TABLE) {
        this.allTableData.push(node);
      } else if (node.type === nodeType.GROUP) {
        if (node.children) {
          this.getAllTableData(node.children);
        }
      }
    });
  }

  returnChildrenForFGroups(n) {
    let fgs: any[] = [];

    if (n?.type === 'FIELD_GROUP') {
      if (n?.children?.length) {
        n.children.forEach((child) => {
          if (child.type === 'FIELD_GROUP') {
            fgs = fgs.concat(this.returnChildrenForFGroups(child));
          } else {
            const obj = {
              name: child.title,
              id: child.key,
              type: child.data.f_type
            };
            fgs.push(obj);
          }
        });
      }
    }

    return fgs;
  }

  populateQueryFieldData() {
    this.queryFieldData = this.allTableData
      .filter((d) => d.key === this.currentTableId)[0]
      ?.children?.flatMap((f) => {
        if (f.type === 'FIELD') {
          return [
            {
              name: f.title,
              id: f.key,
              type: f.data?.f_type,
              tableId: f.data?.f_tableId,
              tfield: []
            }
          ];
        } else if (f.type === 'FIELD_GROUP' && Array.isArray(f?.children)) {
          return this.returnChildrenForFGroups(f);
        }
        return [];
      });
  }

  constructFieldOptions() {
    this.fieldOptions = [
      ...this.tableOptions
        .map((t) => {
          return {
            name: t.name,
            id: t.id,
            items: [
              ...this.allTableData
                .filter((d) => d.key === t.id)[0]
                .children.filter((f) => !GlobalConstants.auditFields.includes(f.title))
                .map((k) => {
                  if (k.type === 'FIELD_GROUP') {
                    return this.returnChildrenForFGroups(k);
                  }
                  return {
                    name: k.title,
                    id: k.key,
                    type: k.data.f_type
                  };
                })
                .flat()
                .sort((a, b) => a.name.localeCompare(b.name))
            ]
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name))
    ];
  }

  fetchAndCacheIndicesForAliases() {
    const tableIds = Array.from(new Set<string>(this.tableAliasValue.map((tav) => tav.table || tav.t_tableId).filter(Boolean)));
    const uncachedTableIds = tableIds.filter((id) => !this.indexMap.has(id));
    if (!uncachedTableIds.length) {
      this.populateAliasChips();
      this.cdr.detectChanges();
      return;
    }
    this.pendingIndexTableIds = [...uncachedTableIds];
    this.fetchNextIndexFromStore();
  }

  fetchNextIndexFromStore() {
    if (!this.pendingIndexTableIds.length) {
      this.populateAliasChips();
      this.cdr.detectChanges();
      return;
    }
    const tableId = this.pendingIndexTableIds[0];
    this.dispatchGetIndices(tableId);
  }

  private dispatchGetIndices(tableId: string): void {
    this.store.dispatch(setIndices({ indices: null }));
    this.store.dispatch(
      getIndices({
        getApiConstants: ApiConstants.getIndex,
        data: { tableId, appId: this.appId, orgId: this.orgId }
      })
    );
  }

  private parseIndexFieldIds(fields: string | string[]): string[] {
    return typeof fields === 'string' ? fields.split(',') : fields || [];
  }

  private sortByCreatedDate(items: any[]): any[] {
    return items.sort((a, b) => {
      const dateA = a.createdDate ? new Date(a.createdDate).getTime() : Number.MAX_SAFE_INTEGER;
      const dateB = b.createdDate ? new Date(b.createdDate).getTime() : Number.MAX_SAFE_INTEGER;
      return dateA - dateB;
    });
  }

  private mapAliasFromResponse(tav: any): any {
    return {
      ...tav,
      aliasId: tav?.sid,
      alias: tav?.aliasName,
      name: this.metaInfoMap[tav.t_tableId],
      aliasBackup: tav.aliasName,
      isInvalid: false,
      errorMessage: '',
      indexSid: tav.indexSid || null,
      recordIdentifierIndexName: null,
      recordIdentifierFields: null
    };
  }

  populateAliasChips() {
    this.tableAliasValue.forEach((tav) => {
      if (tav.indexSid) {
        const tableId = tav.table || tav.t_tableId;
        const indexes = this.indexMap.get(tableId) || [];
        const matchedIndex = indexes.find((idx) => idx.sid === tav.indexSid);
        if (matchedIndex) {
          const fieldIds = this.parseIndexFieldIds(matchedIndex.fields);
          tav.recordIdentifierIndexName = matchedIndex.indexName;
          tav.recordIdentifierFields = fieldIds.map((fId) => this.metaInfoMap[fId] || fId);
        }
      }
    });
  }

  openAliasMenu(event: Event, row: any, index: number) {
    this.aliasMenuItems = [
      {
        label: this.translateService.instant('CONFIGURE_RECORD_IDENTIFIER'),
        icon: 'pi pi-key',
        command: () => this.openRecordIdentifierDialog(row, index)
      },
      {
        label: this.translateService.instant('REMOVE_ALIAS'),
        icon: 'pi pi-trash',
        command: () => this.deleteAlias(index)
      }
    ];
  }

  openRecordIdentifierDialog(aliasRow: any, index: number) {
    this.selectedAliasForRI = aliasRow;
    this.selectedIndexSidForRI = aliasRow.indexSid || null;
    this.showRecordIdentifierDialog = true;

    const tableId = aliasRow.table || aliasRow.t_tableId;
    const cached = this.indexMap.get(tableId);
    if (cached) {
      this.availableIndexesForRI = this.mapIndexesForDropdown(cached);
    } else {
      this.availableIndexesForRI = [];
      this.dispatchGetIndices(tableId);
    }
  }

  mapIndexesForDropdown(indexes: any[]) {
    return indexes.map((idx) => {
      const fieldNames = this.parseIndexFieldIds(idx.fields).map((fId) => this.metaInfoMap[fId] || fId);
      return {
        ...idx,
        label: idx.indexName,
        fieldNames
      };
    });
  }

  onRecordIdentifierDialogHide() {
    this.showRecordIdentifierDialog = false;
    this.selectedAliasForRI = null;
    this.availableIndexesForRI = [];
    this.selectedIndexSidForRI = null;
  }

  applyRecordIdentifier() {
    if (this.selectedAliasForRI) {
      const selectedIdx = this.availableIndexesForRI.find((idx) => idx.sid === this.selectedIndexSidForRI);
      this.selectedAliasForRI.indexSid = this.selectedIndexSidForRI;
      this.selectedAliasForRI.recordIdentifierIndexName = selectedIdx?.indexName || null;
      this.selectedAliasForRI.recordIdentifierFields = selectedIdx?.fieldNames || null;
    }
    this.showRecordIdentifierDialog = false;
  }

  initializeTableOptions() {
    this.initializeTableOrders();
    this.getAllTableData(this.tableOrders);
    this.tableOptions = [
      ...this.allTableData
        .filter(
          (node) => node?.data?.t_type === DMConstants.TRANS_ONLY || node?.data?.t_type === DMConstants.TRANS_ANALY
        )
        .map((d) => {
          return {
            name: d.title,
            id: d.key
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name))
    ];
  }

  ngOnInit(): void {
    this.applicationMetaData = this.appGlobalService.get('appmetaInfo');
    let settings = this.appGlobalService.get('technologySettings');
    this.isDeactivateRecords = settings.deactivateRecords;
    if (this.isDeactivateRecords) {
      const defaultCudActions = this.cudActions;
      this.cudActions = [
        ...defaultCudActions.slice(0, 4),
        { name: 'Activate', value: cudAction.ACTIVATE },
        { name: 'Deactivate', value: cudAction.DEACTIVATE },
        defaultCudActions[4]
      ];
    }
    this.updateCudActionOptions();
    if (this.isDeactivateRecords) {
      this.actionOrder.push('activate');
      this.actionOrder.push('deactivate');
      // eslint-disable-next-line dot-notation
      this.cudActionOrder['activate'] = [];
      // eslint-disable-next-line dot-notation
      this.cudActionOrder['deactivate'] = [];
      // eslint-disable-next-line dot-notation
      this.enabledActions['activate'] = { name: 'ACT_ACTIVATE', value: true, keyName: cudAction.ACTIVATE };
      // eslint-disable-next-line dot-notation
      this.enabledActions['deactivate'] = { name: 'ACT_DEACTIVATE', value: true, keyName: cudAction.DEACTIVATE };
      // eslint-disable-next-line dot-notation
      this.selectedTables['activate'] = [];
      // eslint-disable-next-line dot-notation
      this.selectedTables['deactivate'] = [];
    }
    this.activeIndex = 0;
    this.currentTableId = this.formData?.sid;
    this.allTableData = [];
    this.initializeTableOptions();
    this.constructFieldOptions();
    const metaInfoSub = this.store.select(metaInfo).subscribe((res) => {
      this.metaInfoMap = res;
    });
    this.addToSubscriptionsList(metaInfoSub);
    const indicesSub = this.store.select(indices).subscribe((res: any) => {
      if (res) {
        const filtered = res.filter((idx) => idx.indexType === 'PRIMARY' || idx.indexType === 'UNIQUE');
        if (this.pendingIndexTableIds.length) {
          const tableId = this.pendingIndexTableIds.shift();
          if (tableId) {
            this.indexMap.set(tableId, filtered);
          }
          this.fetchNextIndexFromStore();
        } else if (this.showRecordIdentifierDialog) {
          const tableId = this.selectedAliasForRI?.table || this.selectedAliasForRI?.t_tableId;
          if (tableId) {
            this.indexMap.set(tableId, filtered);
          }
          this.availableIndexesForRI = this.mapIndexesForDropdown(filtered);
          this.cdr.detectChanges();
        }
      }
    });
    this.addToSubscriptionsList(indicesSub);
    this.populateQueryFieldData();
    this.getDataFromFS();
  }

  getDataFromFS(): void {
    const version = this.appGlobalService.get('appVersion');
    const queryObject = {
      collectionName: `QueryViewConfiguration_${version}`,
      filter: [
        { field: 'appId', operator: '==', value: String(this.appId || '') },
        { field: 'tableId', operator: '==', value: String(this.currentTableId || '') },
        { field: 'type', operator: '==', value: 'TABLE_ALIAS' }
      ]
    };
    this.getCudData(queryObject);
  }

  private getCudData(queryObject: any): void {
    try {
      if (this.fsCudSub && typeof (this.fsCudSub as any).unsubscribe === 'function') {
        (this.fsCudSub as any).unsubscribe();
      }

      const extractAlias = (d: any) => ({
        sid: d.sid,
        aliasName: d.aliasName,
        aliasId: d.aliasId,
        t_tableId: d.t_tableId,
        orgId: d.orgId || this.orgId,
        recDeleted: d.recDeleted || false
      });

      this.fsCudSub = this.fsService.fireService(queryObject).subscribe(
        (res: any[]) => {
          if (!res || res.length === 0) {
            return;
          }
          if (this.cudInitial) {
            this.cudInitial = false;
            const filtered = res.filter(
              (dt: any) => !dt.payload.doc.metadata.fromCache && !dt.payload.doc.data().recDeleted
            );
            this.cudAliases = filtered.map((obj: any) => extractAlias(obj.payload.doc.data()));
          } else {
            res.forEach((dt: any) => {
              const docData = dt.payload.doc.data();
              const sid = docData.sid;
              const idx = this.cudAliases.findIndex((a) => a.sid === sid);
              if (docData.recDeleted) {
                if (idx !== -1) {
                  this.cudAliases.splice(idx, 1);
                }
              } else if (dt.payload.doc.exists || dt.type === 'added' || dt.type === 'modified') {
                const newAlias = extractAlias(docData);
                if (idx !== -1) {
                  this.cudAliases[idx] = { ...this.cudAliases[idx], ...newAlias };
                } else {
                  this.cudAliases.push(newAlias);
                }
              }
            });
          }
          this.tableNames = this.cudAliases?.length
            ? this.cudAliases
                .map((a) => this.metaInfoMap?.[a.t_tableId] || a.aliasName)
                ?.filter((n) => !!n)
                ?.join(', ')
            : '';
        },
        (error) => {
          console.error(error);
        }
      );
      if (this.fsCudSub) {
        this.subscriptions.push(this.fsCudSub);
      }
    } catch (e) {
      console.warn(e);
    }
  }

  ngOnDestroy(): void {
    if (this.fsCudSub) {
      this.fsCudSub.unsubscribe();
    }
    if (this.subscriptions?.length) {
      this.subscriptions.forEach((s) => {
        if (s && typeof s.unsubscribe === 'function') {
          s.unsubscribe();
        }
      });
    }
  }

  ngAfterViewInit() {
    this.updateCudActionOptions();
    this.updateNavigators();
  }

  updateCudActionOptions(): void {
    if (!this.isDeactivateRecords) {
      this.cudActions = [
        this.cudActionsMap.noAction,
        this.cudActionsMap.insert,
        this.cudActionsMap.upsert,
        this.cudActionsMap.update,
        this.cudActionsMap.delete
      ];
    }
  }

  checkVisibility(value: any) {
    if (value.action === 'NO_ACTION') {
      return false;
    }
    return true;
  }

  editqb(val: any, action: any) {
    this.showQueryBuilder = true;
    this.lastSelectedQbProp = {
      tableId: val.table,
      action: val.action,
      tableAliasId: val.aliasId,
      sid: val.sid,
      actionSequence: action,
      currentTableId: this.currentTableId,
      queryBuilderId: val?.queryBuilderId
    };
    const qbId = val?.queryBuilderId;
    this.conditional = qbId ? JSON.stringify({ sid: qbId }) : null;
    const qBsid = val.appId + val.aliasId + null + this.conditional + 'name response' + action + val.action;
    this.conditionProperty = {
      name: 'CUDConditional',
      lookupTo: 'CUD',
      instance: this.conditional + action,
      appUserNeeded: true,
      value: this.conditional,
      details: {
        sid: this.conditional,
        operation: action
      },
      querryBuilderSid: qBsid,
      isRolesNeeded: true
    };
  }

  callDeleteReferences(deleteRefSid) {
    this.baseService.delete(ApiConstants.deleteReferenceBySid, { sid: deleteRefSid }).subscribe({
      next: (res) => {
        console.log(res)
      }
    });
  }

  clearQb(value) {
    if (value && value?.sid) {
      if (value?.cleared) {
        let referenceDeleteSid = `${this.appGlobalService.get('appId')}_$_${this.lastSelectedQbProp['sid']}_$_${this.appGlobalService.get('appId')}_$_${this.lastSelectedQbProp['queryBuilderId']}$_$QUERY_BUILDER`;
        this.callDeleteReferences(referenceDeleteSid);

        this.lastSelectedQbProp['queryBuilderId'] = null;

        this.cudActionOrder[this.lastSelectedQbProp['actionSequence']].forEach((o) => {
          if (
            o?.queryBuilderId != value?.sid &&
            o.table == this.lastSelectedQbProp['tableId'] &&
            this.lastSelectedQbProp['tableAliasId'] == o.aliasId
          ) {
            o.queryBuilderId = null;
          }
        });

        let actionOrder = JSON.parse(this.formData?.t_cud_qv_action_order);
        actionOrder[this.lastSelectedQbProp['actionSequence']].forEach(a => {
          let aliasId = JSON.parse(a?.alias)?.sid;
          if (
            this.lastSelectedQbProp['tableAliasId'] == aliasId &&
            this.lastSelectedQbProp['tableId'] == a?.table &&
            this.lastSelectedQbProp['action'] == a?.action
          ) {
            a['queryBuilderId'] = null;
          }
        });

        actionOrder = JSON.stringify(actionOrder);

        const payload = {
          t_cud_qv_tables: this.formData?.t_cud_qv_tables,
          t_cud_qv_action_order: actionOrder,
          t_cud_qv_mapping: this.formData?.t_cud_qv_mapping,
          old_t_cud_qv_action_order: this.formData?.t_cud_qv_action_order
        };

        this.callApi(payload, false, true, false, true);

      } else {
        this.lastSelectedQbProp['queryBuilderId'] = value?.sid;
        let oldQbId = null;

        this.cudActionOrder[this.lastSelectedQbProp['actionSequence']].forEach(o => {
          if (
            o?.queryBuilderId != value?.sid &&
            o.table == this.lastSelectedQbProp['tableId'] &&
            this.lastSelectedQbProp['tableAliasId'] == o.aliasId
          ) {
            oldQbId = o?.queryBuilderId;
            o.queryBuilderId = value?.sid;
          }
        });

        if (value?.ruleCopied) {
          let addedRef = [
            {
              modelId: this.lastSelectedQbProp['tableAliasId'],
              modelType: "TABLE_ALIAS",
              referredModelId: value?.sid,
              referredModelType: "QUERY_BUILDER",
              propertyName: "QUERYVIEW_CUD_CONFIGURATION",
              appId: this.appGlobalService.get('appId'),
              orgId: this.appGlobalService.get('orgId'),
              referredAppId: this.appGlobalService.get('appId'),
              manualChange: true,
              sid: `${this.appGlobalService.get('appId')}_${this.lastSelectedQbProp['tableAliasId']}_${this.appGlobalService.get('appId')}_${value?.sid}_CUDConditional_${this.lastSelectedQbProp['action']}_${this.lastSelectedQbProp['actionSequence']}`,
              additionalInfo: this.lastSelectedQbProp
            }
          ];
          this.addOrDeleteReferences(addedRef, []);
        }

        if (value?.refs && value?.refs.deletedReference) {
          let cudDeleteRefs: any[] = [];
          value?.refs.deletedReference.forEach(d => {
            cudDeleteRefs.push({
              modelId: d.referredModelId,
              referredModelId: d.modelId,
              propertyName: 'QUERYVIEW_CUD_CONFIGURATION'
            });
          });
          this.addOrDeleteReferences([], cudDeleteRefs);
        } else if (oldQbId) {
          let referenceDeleteSid = `${this.appGlobalService.get('appId')}_${this.lastSelectedQbProp['tableAliasId']}_${this.appGlobalService.get('appId')}_${oldQbId}_CUDConditional_${this.lastSelectedQbProp['action']}_${this.lastSelectedQbProp['actionSequence']}`;
          this.callDeleteReferences(referenceDeleteSid);
        }

        this.showQueryBuilder = false;
        this.cdr.detectChanges();
      }
    }
  }

  changeQb(value) {
    if (value && value?.sid) {
      this.lastSelectedQbProp['queryBuilderId'] = value?.sid;
      let oldQbId = null;

      this.cudActionOrder[this.lastSelectedQbProp['actionSequence']].forEach((o) => {
        if (
          o?.queryBuilderId != value?.sid &&
          o.table == this.lastSelectedQbProp['tableId'] &&
          this.lastSelectedQbProp['tableAliasId'] == o.aliasId
        ) {
          oldQbId = o?.queryBuilderId;
          o.queryBuilderId = value?.sid;
        }
      });

      if (value?.refs && value?.refs.deletedReference) {
        let cudDeleteRefs: any[] = [];
        value?.refs.deletedReference.forEach((d) => {
          cudDeleteRefs.push({
            modelId: d.referredModelId,
            referredModelId: d.modelId,
            propertyName: 'QUERYVIEW_CUD_CONFIGURATION'
          });
        });
        this.addOrDeleteReferences([], cudDeleteRefs);
      } else if (oldQbId) {
        let referenceDeleteSid = `${this.appGlobalService.get('appId')}_${this.lastSelectedQbProp['sid']}_${this.appGlobalService.get('appId')}_${oldQbId}$_$QUERY_BUILDER`;
        this.callDeleteReferences(referenceDeleteSid);
      }

      this.showQueryBuilder = false;
      this.cdr.detectChanges();
    } else {
      this.showQueryBuilder = false;
    }
  }

  addOrDeleteReferences(addedReference, deletedReference) {
    let fldProps;
    if (deletedReference.length && deletedReference.length != 0) {
      fldProps = [
        {
          sid: deletedReference[0].modelId,
          aid: this.appGlobalService.get('appId'),
          orgId: this.appGlobalService.get('orgId'),
          type: 'FIELD',
          name: this.appGlobalService?.get('appmetaInfo')[deletedReference[0].modelId],
          f_tableId: this.fsData.find((item) => item.sid === deletedReference[0].modelId)?.f_tableId
        }
      ];
    } else {
      fldProps = [];
    }
    let datatosend = {
      addedReference: addedReference.length ? addedReference : undefined,
      deletedReference: deletedReference.length ? deletedReference : undefined,
      fieldProperties: fldProps
    };
    this.store.dispatch(
      updateAppDM({
        apiConstants: ApiConstants.updateFieldsAndReference,
        appDMData: datatosend
      })
    );
  }

  @HostListener('window:resize')
  onResize() {
    this.updateNavigators();
  }

  updateNavigators() {
    // find current numVisible based on window width
    let currentVisible = this.numVisible;
    for (const option of this.responsiveOptions) {
      if (window.innerWidth <= parseInt(option.breakpoint)) {
        currentVisible = option.numVisible;
      }
    }

    this.showNavigators = this.actionOrder.length > currentVisible;
  }
}



